(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2587],{

/***/ 36916:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "J": function() { return /* reexport */ PropertyCard; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Box/Box.js
var Box = __webpack_require__(646523);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Link/Link.js
var Link = __webpack_require__(422470);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Image/Image.js + 1 modules
var Image = __webpack_require__(897009);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Text/index.js
var Text = __webpack_require__(76614);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Button/IconButton.js + 4 modules
var IconButton = __webpack_require__(241538);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/helpers/currencyHelpers.mjs
var currencyHelpers = __webpack_require__(97166);
;// CONCATENATED MODULE: ./node_modules/@opendoor/cinderblocks/es/marketplace/PropertyCard/PropertyCard.mjs
function cov_2hvthg5jk2() {
    var path = "/__w/code/code/js/packages/cinderblocks/src/marketplace/PropertyCard/PropertyCard.tsx";
    var hash = "e7cc4efcf932e0be8f30eddefe086b5019605309";
    var global = new Function("return this")();
    var gcv = "__coverage__";
    var coverageData = {
        path: "/__w/code/code/js/packages/cinderblocks/src/marketplace/PropertyCard/PropertyCard.tsx",
        statementMap: {
            "0": {
                start: {
                    line: 21,
                    column: 57
                },
                end: {
                    line: 121,
                    column: 1
                }
            },
            "1": {
                start: {
                    line: 35,
                    column: 2
                },
                end: {
                    line: 120,
                    column: 4
                }
            }
        },
        fnMap: {
            "0": {
                name: "(anonymous_0)",
                decl: {
                    start: {
                        line: 21,
                        column: 57
                    },
                    end: {
                        line: 21,
                        column: 58
                    }
                },
                loc: {
                    start: {
                        line: 34,
                        column: 6
                    },
                    end: {
                        line: 121,
                        column: 1
                    }
                },
                line: 34
            }
        },
        branchMap: {
            "0": {
                loc: {
                    start: {
                        line: 50,
                        column: 11
                    },
                    end: {
                        line: 54,
                        column: 11
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 50,
                            column: 11
                        },
                        end: {
                            line: 50,
                            column: 16
                        }
                    },
                    {
                        start: {
                            line: 51,
                            column: 12
                        },
                        end: {
                            line: 53,
                            column: 19
                        }
                    }
                ],
                line: 50
            },
            "1": {
                loc: {
                    start: {
                        line: 55,
                        column: 11
                    },
                    end: {
                        line: 59,
                        column: 11
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 55,
                            column: 11
                        },
                        end: {
                            line: 55,
                            column: 34
                        }
                    },
                    {
                        start: {
                            line: 56,
                            column: 12
                        },
                        end: {
                            line: 58,
                            column: 19
                        }
                    }
                ],
                line: 55
            },
            "2": {
                loc: {
                    start: {
                        line: 61,
                        column: 9
                    },
                    end: {
                        line: 72,
                        column: 9
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 61,
                            column: 9
                        },
                        end: {
                            line: 61,
                            column: 24
                        }
                    },
                    {
                        start: {
                            line: 62,
                            column: 10
                        },
                        end: {
                            line: 71,
                            column: 16
                        }
                    }
                ],
                line: 61
            },
            "3": {
                loc: {
                    start: {
                        line: 64,
                        column: 27
                    },
                    end: {
                        line: 64,
                        column: 46
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 64,
                            column: 27
                        },
                        end: {
                            line: 64,
                            column: 37
                        }
                    },
                    {
                        start: {
                            line: 64,
                            column: 41
                        },
                        end: {
                            line: 64,
                            column: 46
                        }
                    }
                ],
                line: 64
            },
            "4": {
                loc: {
                    start: {
                        line: 77,
                        column: 13
                    },
                    end: {
                        line: 77,
                        column: 34
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 77,
                            column: 13
                        },
                        end: {
                            line: 77,
                            column: 17
                        }
                    },
                    {
                        start: {
                            line: 77,
                            column: 21
                        },
                        end: {
                            line: 77,
                            column: 34
                        }
                    }
                ],
                line: 77
            },
            "5": {
                loc: {
                    start: {
                        line: 79,
                        column: 11
                    },
                    end: {
                        line: 88,
                        column: 11
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 79,
                            column: 11
                        },
                        end: {
                            line: 79,
                            column: 16
                        }
                    },
                    {
                        start: {
                            line: 80,
                            column: 12
                        },
                        end: {
                            line: 87,
                            column: 15
                        }
                    }
                ],
                line: 79
            },
            "6": {
                loc: {
                    start: {
                        line: 89,
                        column: 11
                    },
                    end: {
                        line: 98,
                        column: 11
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 89,
                            column: 11
                        },
                        end: {
                            line: 89,
                            column: 15
                        }
                    },
                    {
                        start: {
                            line: 90,
                            column: 12
                        },
                        end: {
                            line: 97,
                            column: 15
                        }
                    }
                ],
                line: 89
            },
            "7": {
                loc: {
                    start: {
                        line: 99,
                        column: 11
                    },
                    end: {
                        line: 108,
                        column: 11
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 99,
                            column: 11
                        },
                        end: {
                            line: 99,
                            column: 23
                        }
                    },
                    {
                        start: {
                            line: 100,
                            column: 12
                        },
                        end: {
                            line: 107,
                            column: 15
                        }
                    }
                ],
                line: 99
            },
            "8": {
                loc: {
                    start: {
                        line: 112,
                        column: 13
                    },
                    end: {
                        line: 112,
                        column: 48
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 112,
                            column: 13
                        },
                        end: {
                            line: 112,
                            column: 25
                        }
                    },
                    {
                        start: {
                            line: 112,
                            column: 29
                        },
                        end: {
                            line: 112,
                            column: 48
                        }
                    }
                ],
                line: 112
            },
            "9": {
                loc: {
                    start: {
                        line: 115,
                        column: 13
                    },
                    end: {
                        line: 115,
                        column: 30
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 115,
                            column: 13
                        },
                        end: {
                            line: 115,
                            column: 17
                        }
                    },
                    {
                        start: {
                            line: 115,
                            column: 21
                        },
                        end: {
                            line: 115,
                            column: 30
                        }
                    }
                ],
                line: 115
            }
        },
        s: {
            "0": 0,
            "1": 0
        },
        f: {
            "0": 0
        },
        b: {
            "0": [
                0,
                0
            ],
            "1": [
                0,
                0
            ],
            "2": [
                0,
                0
            ],
            "3": [
                0,
                0
            ],
            "4": [
                0,
                0
            ],
            "5": [
                0,
                0
            ],
            "6": [
                0,
                0
            ],
            "7": [
                0,
                0
            ],
            "8": [
                0,
                0
            ],
            "9": [
                0,
                0
            ]
        },
        _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
        hash: "e7cc4efcf932e0be8f30eddefe086b5019605309"
    };
    var coverage = global[gcv] || (global[gcv] = {});
    if (!coverage[path] || coverage[path].hash !== hash) {
        coverage[path] = coverageData;
    }
    var actualCoverage = coverage[path];
    {
        // @ts-ignore
        cov_2hvthg5jk2 = function cov_2hvthg5jk2() {
            return actualCoverage;
        };
    }
    return actualCoverage;
}
cov_2hvthg5jk2();



cov_2hvthg5jk2().s[0]++;
var PropertyCard = function PropertyCard(_ref) {
    var _ref2;
    var beds = _ref.beds, baths = _ref.baths, city = _ref.city, dwellingType = _ref.dwellingType, estimatedMonthlyPayment = _ref.estimatedMonthlyPayment, href = _ref.href, isFavorite = _ref.isFavorite, neighborhood = _ref.neighborhood, onFavoritePress = _ref.onFavoritePress, photoUrl = _ref.photoUrl, price = _ref.price, sqft = _ref.sqft;
    cov_2hvthg5jk2().f[0]++;
    cov_2hvthg5jk2().s[1]++;
    return /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        flexDirection: "column",
        width: "100%"
    }, /*#__PURE__*/ react.createElement(Link/* Link */.r, {
        href: href,
        analyticsName: "marketplace-property-card-image-link"
    }, /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        width: "100%",
        mb: "$8x",
        borderRadius: "$8x",
        overflow: "hidden"
    }, /*#__PURE__*/ react.createElement(Image/* Image */.E, {
        alt: "Main view of property",
        borderRadius: "$8x",
        source: {
            uri: photoUrl
        },
        resizeMode: "cover",
        aspectRatio: 16 / 9
    }))), /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        mb: 8
    }, /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        flexDirection: "row",
        alignItems: "baseline"
    }, (cov_2hvthg5jk2().b[0][0]++, price) && (cov_2hvthg5jk2().b[0][1]++, /*#__PURE__*/ react.createElement(Text/* Text */.x, {
        tag: "span",
        color: "$contentPrimary",
        typography: "$labelXlarge",
        mr: 4
    }, (0,currencyHelpers/* formatCurrency */.xG)(price))), (cov_2hvthg5jk2().b[1][0]++, estimatedMonthlyPayment) && (cov_2hvthg5jk2().b[1][1]++, /*#__PURE__*/ react.createElement(Text/* Text */.x, {
        tag: "span",
        color: "$contentTertiary",
        typography: "$bodySmall",
        ml: 4
    }, (0,currencyHelpers/* formatCurrency */.xG)(estimatedMonthlyPayment), "/month est."))), (cov_2hvthg5jk2().b[2][0]++, onFavoritePress) && (cov_2hvthg5jk2().b[2][1]++, /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        alignSelf: "center",
        justifyContent: "flex-end"
    }, /*#__PURE__*/ react.createElement(IconButton/* FavoriteButton */._6, {
        isFavorited: (_ref2 = (cov_2hvthg5jk2().b[3][0]++, isFavorite)) !== null && _ref2 !== void 0 ? _ref2 : (cov_2hvthg5jk2().b[3][1]++, false),
        analyticsName: "marketplace-property-card-favorite-button",
        onPress: onFavoritePress,
        size: "small",
        variant: "default",
        alignSelf: "center"
    })))), /*#__PURE__*/ react.createElement(Link/* Link */.r, {
        href: href,
        analyticsName: "marketplace-property-card-info-link"
    }, /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        flexDirection: "row",
        alignItems: "baseline",
        width: "100%"
    }, /*#__PURE__*/ react.createElement(Text/* Text */.x, {
        tag: "span",
        typography: "$bodySmall",
        color: "$contentTertiary"
    }, (cov_2hvthg5jk2().b[4][0]++, beds) && (cov_2hvthg5jk2().b[4][1]++, "".concat(beds, " bds"))), (cov_2hvthg5jk2().b[5][0]++, baths) && (cov_2hvthg5jk2().b[5][1]++, /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(Text/* Text */.x, {
        tag: "span",
        typography: "$bodySmall",
        color: "$contentStateInactiveSecondary"
    }, " • "), /*#__PURE__*/ react.createElement(Text/* Text */.x, {
        tag: "span",
        typography: "$bodySmall",
        color: "$contentTertiary"
    }, "".concat(baths, " ba")))), (cov_2hvthg5jk2().b[6][0]++, sqft) && (cov_2hvthg5jk2().b[6][1]++, /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(Text/* Text */.x, {
        tag: "span",
        typography: "$bodySmall",
        color: "$contentStateInactiveSecondary"
    }, " • "), /*#__PURE__*/ react.createElement(Text/* Text */.x, {
        tag: "span",
        typography: "$bodySmall",
        color: "$contentTertiary"
    }, "".concat(sqft.toLocaleString(), " sqft")))), (cov_2hvthg5jk2().b[7][0]++, dwellingType) && (cov_2hvthg5jk2().b[7][1]++, /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(Text/* Text */.x, {
        tag: "span",
        typography: "$bodySmall",
        color: "$contentStateInactiveSecondary"
    }, " • "), /*#__PURE__*/ react.createElement(Text/* Text */.x, {
        tag: "span",
        typography: "$bodySmall",
        color: "$contentTertiary"
    }, dwellingType)))), /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        flexDirection: "row",
        alignItems: "baseline"
    }, /*#__PURE__*/ react.createElement(Text/* Text */.x, {
        tag: "span",
        mr: "$1x",
        typography: "$bodySmall",
        color: "$contentTertiary"
    }, (cov_2hvthg5jk2().b[8][0]++, neighborhood) && (cov_2hvthg5jk2().b[8][1]++, "".concat(neighborhood, ", "))), /*#__PURE__*/ react.createElement(Text/* Text */.x, {
        tag: "span",
        mr: "$1x",
        typography: "$bodySmall",
        color: "$contentTertiary"
    }, (cov_2hvthg5jk2().b[9][0]++, city) && (cov_2hvthg5jk2().b[9][1]++, "".concat(city))))));
}; //# sourceMappingURL=PropertyCard.mjs.map

;// CONCATENATED MODULE: ./node_modules/@opendoor/cinderblocks/es/marketplace/PropertyCard/index.mjs
function cov_hgnyifubm() {
    var path = "/__w/code/code/js/packages/cinderblocks/src/marketplace/PropertyCard/index.ts";
    var hash = "883a4eaa8cfc30ef36a7e8ea47d91bd450aaf2b5";
    var global = new Function("return this")();
    var gcv = "__coverage__";
    var coverageData = {
        path: "/__w/code/code/js/packages/cinderblocks/src/marketplace/PropertyCard/index.ts",
        statementMap: {},
        fnMap: {},
        branchMap: {},
        s: {},
        f: {},
        b: {},
        _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
        hash: "883a4eaa8cfc30ef36a7e8ea47d91bd450aaf2b5"
    };
    var coverage = global[gcv] || (global[gcv] = {});
    if (!coverage[path] || coverage[path].hash !== hash) {
        coverage[path] = coverageData;
    }
    var actualCoverage = coverage[path];
    {
        // @ts-ignore
        cov_hgnyifubm = function cov_hgnyifubm() {
            return actualCoverage;
        };
    }
    return actualCoverage;
}
cov_hgnyifubm();
 //# sourceMappingURL=index.mjs.map


/***/ }),

/***/ 284359:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ChevronDown_default; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(626042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(269396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(999534);
/* harmony import */ var react_native_svg__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(502888);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86872);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_tamagui_core__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(785893);






var SvgChevronDown = function(_param) {
    var _size = _param.size, size = _size === void 0 ? 24 : _size, _color = _param.color, color = _color === void 0 ? "$contentPrimary" : _color, inProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "size",
        "color"
    ]);
    var outProps = {};
    if (size && (outProps.width = size, outProps.height = size), color) {
        var colorToken = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_3__.getToken)(color, "color");
        outProps.color = colorToken;
    }
    var props = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24"
    }, inProps, outProps);
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_native_svg__WEBPACK_IMPORTED_MODULE_0__/* .Svg */ .ny, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none"
    }, props), {
        children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_native_svg__WEBPACK_IMPORTED_MODULE_0__/* .Path */ .y$, {
            fill: "currentColor",
            d: "m11.5 15.713 7.35-7.35q.375-.374.887-.363.513.013.888.388t.375.887-.375.888l-7.7 7.675q-.3.3-.675.45t-.75.15-.75-.15-.675-.45l-7.7-7.7Q2 9.763 2.013 9.263q.012-.5.387-.875t.888-.375.887.375z"
        })
    }));
};
var ChevronDown_default = SvgChevronDown;



/***/ }),

/***/ 125923:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ ButtonLoadingAnimation; },
/* harmony export */   "z": function() { return /* binding */ Button; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(626042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(269396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(999534);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(667294);
/* harmony import */ var react_native_web__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(953089);
/* harmony import */ var _opendoor_tokens_studio_dist_bricks_next_tokens_Components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(320129);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86872);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_tamagui_core__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _helpers_tokens__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61274);
/* harmony import */ var _shared_anchorOrButton__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(665243);
/* harmony import */ var _Text__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(76614);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(785893);











var buttonTokens = _opendoor_tokens_studio_dist_bricks_next_tokens_Components__WEBPACK_IMPORTED_MODULE_1__/* .tokens.button */ .T.button, sharedFrameConfig = {
    name: "Button",
    cursor: "pointer",
    userSelect: "none",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    borderWidth: buttonTokens.borderWidth.default,
    animation: "linear",
    pressStyle: {
        scale: (0,_helpers_tokens__WEBPACK_IMPORTED_MODULE_3__/* .getStateTokenValue */ .GJ)(buttonTokens.state.pressedScale)
    },
    variants: {
        variant: function(variant, param) {
            var props = param.props;
            return {
                backgroundColor: props.disabled ? buttonTokens.color.background.state.inactive[variant] : buttonTokens.color.background[variant],
                borderColor: props.disabled ? buttonTokens.color.border.state.inactive[variant] : buttonTokens.color.border[variant],
                hoverStyle: props.disabled ? {} : {
                    backgroundColor: buttonTokens.color.background.state.hover[variant],
                    borderColor: buttonTokens.color.border.state.hover[variant]
                },
                focusVisibleStyle: {
                    outlineStyle: "solid",
                    outlineWidth: buttonTokens.outlineWidth.state.focus.default,
                    outlineOffset: buttonTokens.padding.border.focus,
                    outlineColor: buttonTokens.color.border.state.focused[variant]
                }
            };
        },
        size: function(size) {
            return {
                paddingHorizontal: buttonTokens.padding.leftRight[size],
                paddingVertical: buttonTokens.padding.topBottom[size],
                borderRadius: buttonTokens.cornerRadius[size],
                maxWidth: size in buttonTokens.size.maxWidth ? buttonTokens.size.maxWidth[size].state.default : void 0,
                height: size in buttonTokens.size.height ? buttonTokens.size.height[size] : void 0
            };
        },
        disabled: {
            true: {
                pointerEvents: "none"
            }
        },
        loading: {
            true: {
                pointerEvents: "none"
            }
        }
    }
}, AnchorFrame = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_4__.styled)(_tamagui_core__WEBPACK_IMPORTED_MODULE_4__.Text, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, sharedFrameConfig), {
    tag: "a",
    accessibilityRole: "link",
    textDecorationLine: "none",
    display: "flex",
    position: "relative"
})), ButtonFrame = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_4__.styled)(_tamagui_core__WEBPACK_IMPORTED_MODULE_4__.View, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, sharedFrameConfig), {
    tag: "button",
    accessibilityRole: "button"
})), AnchorOrButtonFrame = (0,_shared_anchorOrButton__WEBPACK_IMPORTED_MODULE_7__/* .createAnchorOrButtonFrame */ .r)({
    AnchorFrame: AnchorFrame,
    ButtonFrame: ButtonFrame
}), ButtonLoadingContainer = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_4__.styled)(_tamagui_core__WEBPACK_IMPORTED_MODULE_4__.View, {
    position: "absolute",
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    zIndex: 1,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    variants: {
        variant: function(variant, param) {
            var props = param.props;
            return {
                backgroundColor: "isDisabled" in props && props.isDisabled ? buttonTokens.color.background.state.inactive[variant] : buttonTokens.color.background[variant]
            };
        },
        frameSize: function(size) {
            return {
                borderRadius: buttonTokens.cornerRadius[size],
                gap: buttonTokens.padding.loadingAnimation[size]
            };
        },
        // isDisabled prop is only used to determine backgound color
        isDisabled: {
            true: {}
        }
    }
}), ButtonLoadingAnimation = function(param) {
    var variant = param.variant, size = param.size, isDisabled = param.isDisabled;
    var colorToken = isDisabled ? buttonTokens.color.content.state.inactive[variant] : buttonTokens.color.content[variant], sizeToken = buttonTokens.size.loadingAnimation[size], borderRadiusToken = buttonTokens.cornerRadius.loadingAnimation.default, colorValue = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_4__.getTokens)().color[colorToken].val, sizeValue = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_4__.getTokens)().size[sizeToken].val, borderRadiusValue = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_4__.getTokens)().radius[borderRadiusToken].val, baseStyles = {
        backgroundColor: colorValue,
        width: sizeValue,
        height: sizeValue,
        borderRadius: borderRadiusValue
    }, dotOne = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(new react_native_web__WEBPACK_IMPORTED_MODULE_8__/* ["default"].Value */ .Z.Value(1)).current, dotTwo = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(new react_native_web__WEBPACK_IMPORTED_MODULE_8__/* ["default"].Value */ .Z.Value(0)).current, dotThree = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(new react_native_web__WEBPACK_IMPORTED_MODULE_8__/* ["default"].Value */ .Z.Value(0)).current, dotFour = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(new react_native_web__WEBPACK_IMPORTED_MODULE_8__/* ["default"].Value */ .Z.Value(0)).current, duration = 300, delay = 50;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var loop = react_native_web__WEBPACK_IMPORTED_MODULE_8__/* ["default"].loop */ .Z.loop(react_native_web__WEBPACK_IMPORTED_MODULE_8__/* ["default"].sequence */ .Z.sequence([
            react_native_web__WEBPACK_IMPORTED_MODULE_8__/* ["default"].parallel */ .Z.parallel([
                react_native_web__WEBPACK_IMPORTED_MODULE_8__/* ["default"].timing */ .Z.timing(dotOne, {
                    toValue: 0,
                    duration: duration,
                    useNativeDriver: !0
                }),
                react_native_web__WEBPACK_IMPORTED_MODULE_8__/* ["default"].timing */ .Z.timing(dotTwo, {
                    toValue: 1,
                    duration: duration,
                    useNativeDriver: !0
                })
            ]),
            react_native_web__WEBPACK_IMPORTED_MODULE_8__/* ["default"].parallel */ .Z.parallel([
                react_native_web__WEBPACK_IMPORTED_MODULE_8__/* ["default"].timing */ .Z.timing(dotTwo, {
                    toValue: 0,
                    duration: duration,
                    useNativeDriver: !0
                }),
                react_native_web__WEBPACK_IMPORTED_MODULE_8__/* ["default"].timing */ .Z.timing(dotThree, {
                    toValue: 1,
                    duration: duration,
                    useNativeDriver: !0
                })
            ]),
            react_native_web__WEBPACK_IMPORTED_MODULE_8__/* ["default"].parallel */ .Z.parallel([
                react_native_web__WEBPACK_IMPORTED_MODULE_8__/* ["default"].timing */ .Z.timing(dotThree, {
                    toValue: 0,
                    duration: duration,
                    useNativeDriver: !0
                }),
                react_native_web__WEBPACK_IMPORTED_MODULE_8__/* ["default"].timing */ .Z.timing(dotFour, {
                    toValue: 1,
                    duration: duration,
                    useNativeDriver: !0
                })
            ]),
            react_native_web__WEBPACK_IMPORTED_MODULE_8__/* ["default"].delay */ .Z.delay(delay),
            react_native_web__WEBPACK_IMPORTED_MODULE_8__/* ["default"].parallel */ .Z.parallel([
                react_native_web__WEBPACK_IMPORTED_MODULE_8__/* ["default"].timing */ .Z.timing(dotFour, {
                    toValue: 0,
                    duration: duration,
                    useNativeDriver: !0
                }),
                react_native_web__WEBPACK_IMPORTED_MODULE_8__/* ["default"].timing */ .Z.timing(dotThree, {
                    toValue: 1,
                    duration: duration,
                    useNativeDriver: !0
                })
            ]),
            react_native_web__WEBPACK_IMPORTED_MODULE_8__/* ["default"].parallel */ .Z.parallel([
                react_native_web__WEBPACK_IMPORTED_MODULE_8__/* ["default"].timing */ .Z.timing(dotThree, {
                    toValue: 0,
                    duration: duration,
                    useNativeDriver: !0
                }),
                react_native_web__WEBPACK_IMPORTED_MODULE_8__/* ["default"].timing */ .Z.timing(dotTwo, {
                    toValue: 1,
                    duration: duration,
                    useNativeDriver: !0
                })
            ]),
            react_native_web__WEBPACK_IMPORTED_MODULE_8__/* ["default"].parallel */ .Z.parallel([
                react_native_web__WEBPACK_IMPORTED_MODULE_8__/* ["default"].timing */ .Z.timing(dotTwo, {
                    toValue: 0,
                    duration: duration,
                    useNativeDriver: !0
                }),
                react_native_web__WEBPACK_IMPORTED_MODULE_8__/* ["default"].timing */ .Z.timing(dotOne, {
                    toValue: 1,
                    duration: duration,
                    useNativeDriver: !0
                })
            ]),
            react_native_web__WEBPACK_IMPORTED_MODULE_8__/* ["default"].delay */ .Z.delay(delay)
        ]));
        return loop.start(), function() {
            loop.stop();
        };
    }, [
        dotOne,
        dotTwo,
        dotThree,
        dotFour
    ]);
    var opacityMinValue = Number(variant === "secondary" ? buttonTokens.computedValues.opacity.loadingAnimation.inverse : buttonTokens.computedValues.opacity.loadingAnimation.default), interpolation = {
        inputRange: [
            0,
            1
        ],
        outputRange: [
            opacityMinValue,
            1
        ]
    };
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(ButtonLoadingContainer, {
        isDisabled: isDisabled,
        variant: variant,
        frameSize: size,
        testID: "button-loading-container",
        children: [
            /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_native_web__WEBPACK_IMPORTED_MODULE_8__/* ["default"].View */ .Z.View, {
                style: [
                    baseStyles,
                    {
                        opacity: dotOne.interpolate(interpolation)
                    }
                ]
            }),
            /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_native_web__WEBPACK_IMPORTED_MODULE_8__/* ["default"].View */ .Z.View, {
                style: [
                    baseStyles,
                    {
                        opacity: dotTwo.interpolate(interpolation)
                    }
                ]
            }),
            /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_native_web__WEBPACK_IMPORTED_MODULE_8__/* ["default"].View */ .Z.View, {
                style: [
                    baseStyles,
                    {
                        opacity: dotThree.interpolate(interpolation)
                    }
                ]
            }),
            /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_native_web__WEBPACK_IMPORTED_MODULE_8__/* ["default"].View */ .Z.View, {
                style: [
                    baseStyles,
                    {
                        opacity: dotFour.interpolate(interpolation)
                    }
                ]
            })
        ]
    });
}, Button = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function(_param, ref) {
    var variant = _param.variant, size = _param.size, disabled = _param.disabled, loading = _param.loading, label = _param.label, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_param, [
        "variant",
        "size",
        "disabled",
        "loading",
        "label"
    ]);
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(AnchorOrButtonFrame, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        variant: variant,
        size: size,
        disabled: disabled,
        focusable: !disabled,
        loading: loading,
        "aria-disabled": disabled || loading,
        ref: ref
    }, rest), {
        children: [
            loading && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(ButtonLoadingAnimation, {
                isDisabled: disabled,
                variant: variant,
                size: size
            }),
            /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_Text__WEBPACK_IMPORTED_MODULE_10__/* .Text */ .x, {
                tag: "span",
                typography: buttonTokens.typography[size],
                color: disabled ? buttonTokens.color.content.state.inactive[variant] : buttonTokens.color.content[variant],
                numberOfLines: 1,
                children: label
            })
        ]
    }));
});



/***/ }),

/***/ 352007:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ TextButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(626042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(269396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(999534);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(667294);
/* harmony import */ var _opendoor_tokens_studio_dist_bricks_next_tokens_Components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(320129);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86872);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_tamagui_core__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _generated_icons__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(201677);
/* harmony import */ var _generated_icons__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(887251);
/* harmony import */ var _helpers_tokens__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61274);
/* harmony import */ var _shared_anchorOrButton__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(665243);
/* harmony import */ var _Text__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(76614);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(785893);











var textButtonTokens = _opendoor_tokens_studio_dist_bricks_next_tokens_Components__WEBPACK_IMPORTED_MODULE_1__/* .tokens.textButton */ .T.textButton, buttonTokens = _opendoor_tokens_studio_dist_bricks_next_tokens_Components__WEBPACK_IMPORTED_MODULE_1__/* .tokens.button */ .T.button, sharedFrameConfig = {
    name: "TextButton",
    display: "flex",
    flexDirection: "row",
    gap: textButtonTokens.padding.labelIconGap.default,
    userSelect: "none",
    cursor: "pointer",
    // Browser resets
    padding: 0,
    borderWidth: 0,
    backgroundColor: "$transparent",
    focusVisibleStyle: {
        outlineStyle: "solid",
        outlineWidth: textButtonTokens.borderWidth.state.default,
        outlineOffset: textButtonTokens.padding.state.focused.default,
        borderRadius: textButtonTokens.cornerRadius.state.focused
    },
    pressStyle: {
        scale: (0,_helpers_tokens__WEBPACK_IMPORTED_MODULE_3__/* .getStateTokenValue */ .GJ)(buttonTokens.state.pressedScale)
    },
    variants: {
        variant: function(variant) {
            return {
                focusVisibleStyle: {
                    outlineColor: variant === "secondaryInverse" ? textButtonTokens.color.border.state.inverse : textButtonTokens.color.border.state.default
                }
            };
        },
        disabled: {
            true: {
                pointerEvents: "none"
            }
        }
    }
}, AnchorFrame = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_4__.styled)(_tamagui_core__WEBPACK_IMPORTED_MODULE_4__.Text, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, sharedFrameConfig), {
    tag: "a",
    accessibilityRole: "link",
    textDecorationLine: "none",
    display: "flex",
    position: "relative"
})), ButtonFrame = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_4__.styled)(_tamagui_core__WEBPACK_IMPORTED_MODULE_4__.View, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, sharedFrameConfig), {
    tag: "button",
    accessibilityRole: "button"
})), AnchorOrButtonFrame = (0,_shared_anchorOrButton__WEBPACK_IMPORTED_MODULE_7__/* .createAnchorOrButtonFrame */ .r)({
    AnchorFrame: AnchorFrame,
    ButtonFrame: ButtonFrame
}), TextButton = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function(_param, ref) {
    var variant = _param.variant, disabled = _param.disabled, label = _param.label, onHoverIn = _param.onHoverIn, onHoverOut = _param.onHoverOut, chevronIcon = _param.chevronIcon, fontWeight = _param.fontWeight, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_param, [
        "variant",
        "disabled",
        "label",
        "onHoverIn",
        "onHoverOut",
        "chevronIcon",
        "fontWeight"
    ]);
    var _$ref = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_4__.useProps)(rest), _size = _$ref.size, size = _size === void 0 ? "medium" : _size, _$ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!1), isHovering = _$ref1[0], setIsHovering = _$ref1[1], hoverNone = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_4__.useMedia)().hoverNone, handleHoverIn = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(e) {
        !hoverNone && setIsHovering(!0), onHoverIn === null || onHoverIn === void 0 ? void 0 : onHoverIn(e);
    }, [
        hoverNone,
        onHoverIn
    ]), handleHoverOut = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(e) {
        !hoverNone && setIsHovering(!1), onHoverOut === null || onHoverOut === void 0 ? void 0 : onHoverOut(e);
    }, [
        hoverNone,
        onHoverOut
    ]), color = disabled ? textButtonTokens.color.content.state.inactive[variant] : isHovering ? textButtonTokens.color.content.state.hover[variant] : textButtonTokens.color.content[variant];
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(AnchorOrButtonFrame, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        variant: variant,
        disabled: disabled,
        "aria-disabled": disabled,
        focusable: !disabled,
        onHoverIn: handleHoverIn,
        onHoverOut: handleHoverOut,
        ref: ref
    }, rest), {
        children: [
            chevronIcon === "left" && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_generated_icons__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                size: size === "large" ? 24 : 20,
                color: color
            }),
            /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_Text__WEBPACK_IMPORTED_MODULE_10__/* .Text */ .x, {
                tag: "span",
                typography: textButtonTokens.typography[size],
                textDecorationLine: variant === "primary" || chevronIcon ? "none" : "underline",
                color: color,
                fontWeight: fontWeight ? textButtonTokens.fontWeight[fontWeight] : void 0,
                children: label
            }),
            chevronIcon === "right" && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_generated_icons__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                size: size === "large" ? 24 : 20,
                color: color
            })
        ]
    }));
});



/***/ }),

/***/ 897009:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E": function() { return /* binding */ Image_Image; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(626042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(269396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(999534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/exports/Image/index.js + 2 modules
var Image = __webpack_require__(606665);
// EXTERNAL MODULE: ./node_modules/@tamagui/core/dist/cjs/index.js
var cjs = __webpack_require__(86872);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/helpers/analytics.js + 1 modules
var analytics = __webpack_require__(60368);
// EXTERNAL MODULE: ./node_modules/@opendoor/tokens-studio/dist/bricks-next/tokens/Components.js
var Components = __webpack_require__(320129);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Image/helpers.js

var ImageTokens = Components/* tokens.image */.T.image, getBorderRadiusByVariant = function(variant, orientation) {
    switch(variant){
        case "arch":
            return {
                borderTopLeftRadius: ImageTokens.radius.imageCornerRadius.full,
                borderTopRightRadius: ImageTokens.radius.imageCornerRadius.full,
                borderBottomLeftRadius: ImageTokens.radius.imageCornerRadius["16x"],
                borderBottomRightRadius: ImageTokens.radius.imageCornerRadius["16x"]
            };
        case "circle":
            return {
                borderTopLeftRadius: ImageTokens.radius.imageCornerRadius.full,
                borderTopRightRadius: ImageTokens.radius.imageCornerRadius.full,
                borderBottomLeftRadius: ImageTokens.radius.imageCornerRadius.full,
                borderBottomRightRadius: ImageTokens.radius.imageCornerRadius.full
            };
        case "article":
            return {
                borderTopLeftRadius: orientation === "top" || orientation === "left" ? ImageTokens.radius.imageCornerRadius["8x"] : ImageTokens.radius.imageCornerRadius["2x"],
                borderTopRightRadius: orientation === "top" || orientation === "right" ? ImageTokens.radius.imageCornerRadius["8x"] : ImageTokens.radius.imageCornerRadius["2x"],
                borderBottomLeftRadius: orientation === "bottom" || orientation === "left" ? ImageTokens.radius.imageCornerRadius["8x"] : ImageTokens.radius.imageCornerRadius["2x"],
                borderBottomRightRadius: orientation === "bottom" || orientation === "right" ? ImageTokens.radius.imageCornerRadius["8x"] : ImageTokens.radius.imageCornerRadius["2x"]
            };
        default:
            break;
    }
};


// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Image/Image.js










var BaseImageReactNative = (0,cjs.styled)(Image/* default */.Z, {
    name: "Image",
    variants: {
        variant: function(variant, extras) {
            var orientation = extras.props.orientation || "";
            return getBorderRadiusByVariant(variant, orientation);
        }
    }
}), Image_Image = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var analyticsName = _param.analyticsName, _trackImpression = _param.trackImpression, trackImpression = _trackImpression === void 0 ? !1 : _trackImpression, inViewThreshold = _param.inViewThreshold, source = _param.source, _enableZoom = _param.enableZoom, enableZoom = _enableZoom === void 0 ? !1 : _enableZoom, inProps = (0,_object_without_properties/* default */.Z)(_param, [
        "analyticsName",
        "trackImpression",
        "inViewThreshold",
        "source",
        "enableZoom"
    ]);
    inProps.variant === "circle" && (inProps.height = inProps.width);
    var _$ref = (0,_sliced_to_array/* default */.Z)((0,cjs.usePropsAndStyle)(inProps), 2), props = _$ref[0], style = _$ref[1];
    (0,react.useEffect)(function() {
        var imageRef = cjs.isWebTouchable && ref && "current" in ref ? ref.current : void 0;
        if (cjs.isWebTouchable && imageRef && enableZoom) {
            var imageElementScale = 1;
            var SCALE_MAX = 4, start = {
                x: 0,
                y: 0,
                distance: 0
            }, distance = function(event) {
                return Math.hypot(event.touches[0].pageX - event.touches[1].pageX, event.touches[0].pageY - event.touches[1].pageY);
            }, handleTouchStart = function(event) {
                event.touches.length === 2 && (event.preventDefault(), start.x = (event.touches[0].pageX + event.touches[1].pageX) / 2, start.y = (event.touches[0].pageY + event.touches[1].pageY) / 2, start.distance = distance(event));
            }, handleTouchMove = function(event) {
                if (event.touches.length === 2) {
                    event.preventDefault();
                    var scale;
                    (event === null || event === void 0 ? void 0 : event.scale) ? scale = event.scale : scale = distance(event) / start.distance, imageElementScale = Math.min(Math.max(1, scale), SCALE_MAX);
                    var deltaX = ((event.touches[0].pageX + event.touches[1].pageX) / 2 - start.x) * 2, deltaY = ((event.touches[0].pageY + event.touches[1].pageY) / 2 - start.y) * 2, transform = "translate3d(".concat(deltaX, "px, ").concat(deltaY, "px, 0) scale(").concat(imageElementScale, ")");
                    imageRef.style.transform = transform, imageRef.style.webkitTransform = transform, imageRef.style.zIndex = "9999", imageRef.style.transition = "ease 150ms";
                }
            }, handleTouchEnd = function() {
                imageRef.style.transform = "", imageRef.style.webkitTransform = "", imageRef.style.zIndex = "";
            };
            return imageRef === null || imageRef === void 0 ? void 0 : imageRef.addEventListener("touchstart", handleTouchStart), imageRef === null || imageRef === void 0 ? void 0 : imageRef.addEventListener("touchmove", handleTouchMove), imageRef === null || imageRef === void 0 ? void 0 : imageRef.addEventListener("touchend", handleTouchEnd), function() {
                imageRef === null || imageRef === void 0 ? void 0 : imageRef.removeEventListener("touchstart", handleTouchStart), imageRef === null || imageRef === void 0 ? void 0 : imageRef.removeEventListener("touchmove", handleTouchMove), imageRef === null || imageRef === void 0 ? void 0 : imageRef.removeEventListener("touchend", handleTouchEnd);
            };
        }
    }, [
        ref,
        enableZoom
    ]);
    var BaseImageWithProps = /* @__PURE__ */ (0,jsx_runtime.jsx)(BaseImageReactNative, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        accessibilityLabel: props.alt,
        source: source,
        style: style,
        ref: ref
    }));
    return analyticsName && trackImpression ? /* @__PURE__ */ (0,jsx_runtime.jsx)(analytics/* ComponentWithViewTracking */.o, (0,_object_spread/* default */.Z)({
        Component: BaseImageWithProps,
        analyticsName: analyticsName,
        eventName: "imageViewEvent",
        inViewThreshold: inViewThreshold,
        ref: ref
    }, props)) : BaseImageWithProps;
});



/***/ }),

/***/ 329434:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "c": function() { return /* binding */ PhotoCarousel; },
  "r": function() { return /* binding */ PhotoCarouselAspectRatios; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(626042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(269396);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/exports/Animated/index.js + 64 modules
var Animated = __webpack_require__(953089);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/exports/Platform/index.js
var Platform = __webpack_require__(522805);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/exports/Easing/index.js + 2 modules
var Easing = __webpack_require__(763988);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/exports/PanResponder/index.js + 2 modules
var PanResponder = __webpack_require__(964645);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/exports/Text/index.js
var Text = __webpack_require__(24404);
// EXTERNAL MODULE: ./node_modules/@tamagui/core/dist/cjs/index.js
var cjs = __webpack_require__(86872);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Box/Box.js
var Box = __webpack_require__(646523);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Button/IconButton.js + 4 modules
var IconButton = __webpack_require__(241538);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Image/Image.js + 1 modules
var Image = __webpack_require__(897009);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Text/Text.js
var Text_Text = __webpack_require__(435934);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/exports/StyleSheet/index.js + 9 modules
var StyleSheet = __webpack_require__(465620);
// EXTERNAL MODULE: ./node_modules/@opendoor/tokens-studio/dist/bricks-next/tokens/Components.js
var Components = __webpack_require__(320129);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/PhotoCarousel/PhotoCarouselDots.js






var PhotoCarouselDots_image = Components/* tokens.image */.T.image, DOT_HEIGHT = (0,cjs.getTokenValue)(PhotoCarouselDots_image.size.carouselDots.active.height), ACTIVE_DOT_WIDTH = (0,cjs.getTokenValue)(PhotoCarouselDots_image.size.carouselDots.active.width), INACTIVE_DOT_WIDTH = (0,cjs.getTokenValue)(PhotoCarouselDots_image.size.carouselDots.other), DOT_MARGIN = 3, VISIBLE_DOTS = 5, PhotoCarouselDots = function(param) {
    var length = param.length, currentIndex = param.currentIndex;
    var animatedValues = (0,react.useRef)(Array(length).fill(0).map(function() {
        return new Animated/* default.Value */.Z.Value(0);
    }));
    return (0,react.useEffect)(function() {
        animatedValues.current.forEach(function(value, index) {
            Animated/* default.timing */.Z.timing(value, {
                toValue: index === currentIndex ? 1 : 0,
                duration: 300,
                useNativeDriver: !1
            }).start();
        });
    }, [
        currentIndex
    ]), /* @__PURE__ */ (0,jsx_runtime.jsx)(Box/* Box */.x, {
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        children: function() {
            var start = Math.max(0, Math.min(currentIndex - 2, length - VISIBLE_DOTS)), end = Math.min(start + VISIBLE_DOTS, length);
            return Array(length).fill(0).slice(start, end).map(function(_, index) {
                var realIndex = start + index, width = animatedValues.current[realIndex].interpolate({
                    inputRange: [
                        0,
                        1
                    ],
                    outputRange: [
                        INACTIVE_DOT_WIDTH,
                        ACTIVE_DOT_WIDTH
                    ]
                }), opacity = animatedValues.current[realIndex].interpolate({
                    inputRange: [
                        0,
                        1
                    ],
                    outputRange: [
                        0.5,
                        1
                    ]
                });
                return /* @__PURE__ */ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                    "data-testid": "photo-carousel-dot-".concat(realIndex),
                    children: /* @__PURE__ */ (0,jsx_runtime.jsx)(Animated/* default.View */.Z.View, {
                        style: [
                            styles.dot,
                            {
                                width: width,
                                opacity: opacity
                            }
                        ]
                    })
                }, realIndex);
            });
        }()
    });
}, styles = StyleSheet/* default.create */.Z.create({
    dot: {
        height: DOT_HEIGHT,
        backgroundColor: "white",
        borderRadius: DOT_HEIGHT / 2,
        marginHorizontal: DOT_MARGIN
    }
});


;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/PhotoCarousel/PhotoCarousel.js











var DEFAULT_ASPECT_RATIO = 16 / 9, SQUARE_ASPECT_RATIO = 1 / 1;
var PhotoCarouselAspectRatios = /* @__PURE__ */ function(PhotoCarouselAspectRatios2) {
    return PhotoCarouselAspectRatios2[PhotoCarouselAspectRatios2.DEFAULT = DEFAULT_ASPECT_RATIO] = "DEFAULT", PhotoCarouselAspectRatios2[PhotoCarouselAspectRatios2.SQUARE = SQUARE_ASPECT_RATIO] = "SQUARE", PhotoCarouselAspectRatios2;
}(PhotoCarouselAspectRatios || {});
var PhotoCarousel = function(param) {
    var photos = param.photos, children = param.children, ariaLabel = param.ariaLabel, hideNavigation = param.hideNavigation, _aspectRatio = param.aspectRatio, aspectRatio = _aspectRatio === void 0 ? PhotoCarouselAspectRatios.DEFAULT : _aspectRatio, _height = param.height, height = _height === void 0 ? "100%" : _height, _isRounded = param.isRounded, isRounded = _isRounded === void 0 ? !1 : _isRounded;
    var ref = (0,react.useState)(0), currentImageIndex = ref[0], setCurrentImageIndex = ref[1], ref1 = (0,react.useState)(0), containerWidth = ref1[0], setContainerWidth = ref1[1], ref2 = (0,react.useState)(null), panResponder = ref2[0], setPanResponder = ref2[1], offsetX = (0,react.useRef)(new Animated/* default.Value */.Z.Value(0)).current, currentOffset = (0,react.useRef)(0), carouselRef = (0,react.useRef)(null), navigationMessagePosition = (0,react.useRef)(new Animated/* default.Value */.Z.Value(0)).current, ref3 = (0,react.useState)(!1), showNavigationMessage = ref3[0], setShowNavigationMessage = ref3[1], useNativeDriver = Platform/* default.OS */.Z.OS !== "web", onLayout = function(event) {
        var width = event.nativeEvent.layout.width;
        setContainerWidth(width);
    };
    (0,react.useEffect)(function() {
        Animated/* default.timing */.Z.timing(navigationMessagePosition, {
            toValue: showNavigationMessage ? -65 : 0,
            duration: 300,
            easing: Easing/* default.ease */.Z.ease,
            useNativeDriver: useNativeDriver
        }).start();
    }, [
        navigationMessagePosition,
        showNavigationMessage,
        useNativeDriver
    ]), (0,react.useEffect)(function() {
        var responder = PanResponder/* default.create */.Z.create({
            onMoveShouldSetPanResponder: function() {
                return !0;
            },
            onPanResponderGrant: function() {
                offsetX.setValue(currentOffset.current);
            },
            onPanResponderMove: function(evt, gestureState) {
                offsetX.setValue(currentOffset.current + gestureState.dx);
            },
            onPanResponderRelease: function(evt, gestureState) {
                var threshold = containerWidth / 7;
                var newIndex = currentImageIndex;
                gestureState.dx > threshold ? newIndex = currentImageIndex > 0 ? currentImageIndex - 1 : currentImageIndex : gestureState.dx < -threshold && (newIndex = currentImageIndex < photos.length - 1 ? currentImageIndex + 1 : currentImageIndex), newIndex !== currentImageIndex ? Animated/* default.timing */.Z.timing(offsetX, {
                    toValue: -newIndex * containerWidth,
                    duration: 300,
                    easing: Easing/* default.linear */.Z.linear,
                    useNativeDriver: useNativeDriver
                }).start(function() {
                    setCurrentImageIndex(newIndex), currentOffset.current = -newIndex * containerWidth;
                }) : Animated/* default.spring */.Z.spring(offsetX, {
                    toValue: currentOffset.current,
                    useNativeDriver: useNativeDriver
                }).start();
            }
        });
        setPanResponder(responder);
    }, [
        containerWidth,
        photos.length,
        offsetX,
        currentImageIndex,
        useNativeDriver
    ]), (0,react.useEffect)(function() {
        offsetX.setValue(-currentImageIndex * containerWidth), currentOffset.current = -currentImageIndex * containerWidth;
    }, [
        currentImageIndex,
        containerWidth,
        offsetX
    ]);
    var renderImages = function() {
        return photos.map(function(photo, index) {
            return index >= currentImageIndex - 2 && index <= currentImageIndex + 2 ? /* @__PURE__ */ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                width: containerWidth,
                height: "100%",
                "aria-hidden": index !== currentImageIndex,
                children: /* @__PURE__ */ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                    source: {
                        uri: photo.url
                    },
                    alt: photo.alt || "Image ".concat(index + 1),
                    width: "100%",
                    height: "100%"
                })
            }, index) : /* @__PURE__ */ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                width: containerWidth,
                height: "100%",
                "aria-hidden": !0
            }, index);
        });
    }, handlePrev = (0,react.useCallback)(function() {
        currentImageIndex > 0 && setCurrentImageIndex(currentImageIndex - 1);
    }, [
        currentImageIndex
    ]), handleNext = (0,react.useCallback)(function() {
        currentImageIndex < photos.length - 1 && setCurrentImageIndex(currentImageIndex + 1);
    }, [
        currentImageIndex,
        photos.length
    ]);
    (0,react.useEffect)(function() {
        if (!cjs.isWeb) return;
        var handleKeyDown = function(event) {
            event.key === "ArrowLeft" ? handlePrev() : event.key === "ArrowRight" && handleNext(), showNavigationMessage && setShowNavigationMessage(!1);
        }, carouselContainer = carouselRef.current;
        return carouselContainer === null || carouselContainer === void 0 ? void 0 : carouselContainer.addEventListener("keydown", handleKeyDown), function() {
            carouselContainer === null || carouselContainer === void 0 ? void 0 : carouselContainer.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        handleNext,
        handlePrev,
        showNavigationMessage
    ]);
    var atStart = currentImageIndex === 0, atEnd = currentImageIndex === photos.length - 1;
    return /* @__PURE__ */ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
        role: "region",
        "aria-label": ariaLabel || "Photo Carousel",
        tabIndex: 0,
        ref: carouselRef,
        onFocus: function(event) {
            document.activeElement === carouselRef.current && event.relatedTarget !== null && (setShowNavigationMessage(!0), setTimeout(function() {
                setShowNavigationMessage(!1);
            }, 3e3));
        },
        "data-testid": "photo-carousel",
        children: [
            /* @__PURE__ */ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                accessibilityRole: "text",
                accessible: !1,
                style: {
                    position: "absolute",
                    width: 0,
                    height: 0,
                    overflow: "hidden"
                },
                children: [
                    "This is an photo carousel of the property. Swipe left or right to navigate through the photos.",
                    " ",
                    !hideNavigation && "Alternatively, use the next and previous buttons to move between photos."
                ]
            }),
            /* @__PURE__ */ (0,jsx_runtime.jsx)(Box/* Box */.x, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                width: "100%",
                onLayout: onLayout
            }, panResponder && panResponder.panHandlers), {
                children: /* @__PURE__ */ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
                    aspectRatio: aspectRatio,
                    width: "100%",
                    position: "relative",
                    overflow: "hidden",
                    height: height,
                    borderTopLeftRadius: isRounded ? "$16x" : void 0,
                    borderTopRightRadius: isRounded ? "$16x" : void 0,
                    children: [
                        /* @__PURE__ */ (0,jsx_runtime.jsx)(Animated/* default.View */.Z.View, {
                            style: {
                                flexDirection: "row",
                                width: containerWidth * photos.length,
                                height: "100%",
                                transform: [
                                    {
                                        translateX: offsetX
                                    }
                                ]
                            },
                            children: renderImages()
                        }),
                        cjs.isWeb && !hideNavigation ? /* @__PURE__ */ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                !atStart && /* @__PURE__ */ (0,jsx_runtime.jsx)(IconButton/* ChevronBackButton */.jd, {
                                    size: "medium",
                                    position: "absolute",
                                    top: "50%",
                                    left: "$10x",
                                    analyticsName: "",
                                    onPress: handlePrev,
                                    "aria-label": "Previous photo",
                                    "data-testid": "chevron-back-button"
                                }),
                                !atEnd && /* @__PURE__ */ (0,jsx_runtime.jsx)(IconButton/* ChevronForwardButton */.bB, {
                                    size: "medium",
                                    position: "absolute",
                                    top: "50%",
                                    right: "$10x",
                                    analyticsName: "",
                                    onPress: handleNext,
                                    "aria-label": "Next photo",
                                    "data-testid": "chevron-forward-button"
                                })
                            ]
                        }) : null,
                        children,
                        /* @__PURE__ */ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                            position: "absolute",
                            bottom: "$10x",
                            width: containerWidth,
                            alignItems: "center",
                            flexDirection: "row",
                            justifyContent: "center",
                            "data-testid": "photo-carousel-dots",
                            children: /* @__PURE__ */ (0,jsx_runtime.jsx)(PhotoCarouselDots, {
                                length: photos.length,
                                currentIndex: currentImageIndex
                            })
                        }),
                        hideNavigation ? /* @__PURE__ */ (0,jsx_runtime.jsx)(Animated/* default.View */.Z.View, {
                            style: {
                                position: "absolute",
                                bottom: -30,
                                left: 0,
                                right: 0,
                                justifyContent: "center",
                                flexDirection: "row",
                                transform: [
                                    {
                                        translateY: navigationMessagePosition
                                    }
                                ]
                            },
                            children: /* @__PURE__ */ (0,jsx_runtime.jsx)(Text_Text/* Text */.xv, {
                                backgroundColor: "$backgroundInversePrimary",
                                color: "$backgroundPrimary",
                                paddingHorizontal: "$4x",
                                paddingVertical: "$2x",
                                borderRadius: "$10x",
                                typography: "$bodySmall",
                                opacity: 0.7,
                                children: "Use arrow keys to navigate"
                            })
                        }) : null
                    ]
                })
            }))
        ]
    });
};



/***/ }),

/***/ 553757:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ Pill; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(999534);
/* harmony import */ var _opendoor_tokens_studio_dist_bricks_next_tokens_Components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(320129);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86872);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_tamagui_core__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _helpers_convertColor__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(912554);
/* harmony import */ var _helpers_tokens__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(61274);
/* harmony import */ var _Box__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(646523);
/* harmony import */ var _Text__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(76614);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(785893);








var BoxWithRgbaBackground = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_2__.styled)(_Box__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .x, {
    variants: {
        backgroundColorVariant: function(variant) {
            var pillTokens = _opendoor_tokens_studio_dist_bricks_next_tokens_Components__WEBPACK_IMPORTED_MODULE_0__/* .tokens.pill */ .T.pill;
            return variant !== "inverse" ? {
                backgroundColor: pillTokens.color.background[variant]
            } : {
                backgroundColor: (0,_helpers_convertColor__WEBPACK_IMPORTED_MODULE_4__/* .getRGBA */ .ls)((0,_tamagui_core__WEBPACK_IMPORTED_MODULE_2__.getTokenValue)(pillTokens.color.background.default, "color"), (0,_helpers_tokens__WEBPACK_IMPORTED_MODULE_5__/* .getOpacityTokenValue */ .vs)(pillTokens.opacity.backgroundInverse))
            };
        }
    }
}), Pill = function(_param) {
    var label = _param.label, rounded = _param.rounded, _variant = _param.variant, variant = _variant === void 0 ? "default" : _variant, _weight = _param.weight, weight = _weight === void 0 ? "regularWeight" : _weight, dataTestId = _param["data-testid"], props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "label",
        "rounded",
        "variant",
        "weight",
        "data-testid"
    ]);
    var pillTokens = _opendoor_tokens_studio_dist_bricks_next_tokens_Components__WEBPACK_IMPORTED_MODULE_0__/* .tokens.pill */ .T.pill, ref = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_2__.useProps)(props), _size = ref.size, size = _size === void 0 ? "medium" : _size, sizeToken = size === "xsmall" ? "small" : size;
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(BoxWithRgbaBackground, {
        alignItems: "center",
        justifyContent: "center",
        backgroundColorVariant: variant,
        borderColor: pillTokens.color.border[variant],
        borderRadius: rounded ? pillTokens.cornerRadius.rounded : pillTokens.cornerRadius[sizeToken],
        borderWidth: pillTokens.borderWidth.default,
        height: size === "xsmall" ? "auto" : pillTokens.size.height[weight]["".concat(sizeToken, "Size")],
        paddingBottom: size === "medium" ? pillTokens.padding.medium.bottom[weight] : pillTokens.padding.small.topBottom[weight],
        paddingHorizontal: pillTokens.padding[sizeToken].rightLeft,
        paddingTop: size === "medium" ? pillTokens.padding.medium.top[weight] : pillTokens.padding.small.topBottom[weight],
        width: "max-content",
        "data-testid": dataTestId,
        children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Text__WEBPACK_IMPORTED_MODULE_7__/* .Text */ .x, {
            tag: "span",
            typography: size === "xsmall" ? "$bodyXsmall" : pillTokens.typography[weight][size],
            fontWeight: weight === "mediumWeight" ? "$medium" : "$regular",
            color: pillTokens.color.content.label[variant === "black" ? "inverse" : variant],
            children: label
        })
    });
};



/***/ }),

/***/ 273503:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "e": function() { return /* binding */ Lightbox; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(626042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(269396);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/exports/useWindowDimensions/index.js
var useWindowDimensions = __webpack_require__(541682);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/exports/Animated/index.js + 64 modules
var Animated = __webpack_require__(953089);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/exports/PanResponder/index.js + 2 modules
var PanResponder = __webpack_require__(964645);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/exports/Easing/index.js + 2 modules
var Easing = __webpack_require__(763988);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/modules/canUseDom/index.js
var canUseDom = __webpack_require__(313145);
;// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/AccessibilityInfo/index.js
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

'use client';


function isScreenReaderEnabled() {
  return new Promise((resolve, reject) => {
    resolve(true);
  });
}
var prefersReducedMotionMedia = canUseDom/* default */.Z && typeof window.matchMedia === 'function' ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
function isReduceMotionEnabled() {
  return new Promise((resolve, reject) => {
    resolve(prefersReducedMotionMedia ? prefersReducedMotionMedia.matches : true);
  });
}
function addChangeListener(fn) {
  if (prefersReducedMotionMedia != null) {
    prefersReducedMotionMedia.addEventListener != null ? prefersReducedMotionMedia.addEventListener('change', fn) : prefersReducedMotionMedia.addListener(fn);
  }
}
function removeChangeListener(fn) {
  if (prefersReducedMotionMedia != null) {
    prefersReducedMotionMedia.removeEventListener != null ? prefersReducedMotionMedia.removeEventListener('change', fn) : prefersReducedMotionMedia.removeListener(fn);
  }
}
var handlers = {};
var AccessibilityInfo = {
  /**
   * Query whether a screen reader is currently enabled.
   *
   * Returns a promise which resolves to a boolean.
   * The result is `true` when a screen reader is enabled and `false` otherwise.
   */
  isScreenReaderEnabled,
  /**
   * Query whether the user prefers reduced motion.
   *
   * Returns a promise which resolves to a boolean.
   * The result is `true` when a screen reader is enabled and `false` otherwise.
   */
  isReduceMotionEnabled,
  /**
   * Deprecated
   */
  fetch: isScreenReaderEnabled,
  /**
   * Add an event handler. Supported events: reduceMotionChanged
   */
  addEventListener: function addEventListener(eventName, handler) {
    if (eventName === 'reduceMotionChanged') {
      if (!prefersReducedMotionMedia) {
        return;
      }
      var listener = event => {
        handler(event.matches);
      };
      addChangeListener(listener);
      handlers[handler] = listener;
    }
    return {
      remove: () => AccessibilityInfo.removeEventListener(eventName, handler)
    };
  },
  /**
   * Set accessibility focus to a react component.
   */
  setAccessibilityFocus: function setAccessibilityFocus(reactTag) {},
  /**
   * Post a string to be announced by the screen reader.
   */
  announceForAccessibility: function announceForAccessibility(announcement) {},
  /**
   * Remove an event handler.
   */
  removeEventListener: function removeEventListener(eventName, handler) {
    if (eventName === 'reduceMotionChanged') {
      var listener = handlers[handler];
      if (!listener || !prefersReducedMotionMedia) {
        return;
      }
      removeChangeListener(listener);
    }
    return;
  }
};
/* harmony default export */ var exports_AccessibilityInfo = (AccessibilityInfo);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/exports/ScrollView/index.js + 1 modules
var ScrollView = __webpack_require__(806765);
// EXTERNAL MODULE: ./node_modules/@tamagui/core/dist/cjs/index.js
var cjs = __webpack_require__(86872);
// EXTERNAL MODULE: ./node_modules/@tamagui/dialog/dist/esm/Dialog.mjs + 45 modules
var Dialog = __webpack_require__(800310);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Box/Box.js
var Box = __webpack_require__(646523);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Box/PressableBox.js
var PressableBox = __webpack_require__(302267);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Button/IconButton.js + 4 modules
var IconButton = __webpack_require__(241538);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Image/Image.js + 1 modules
var Image = __webpack_require__(897009);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Text/index.js
var Text = __webpack_require__(76614);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/teams/marketplace/components/Lightbox/helpers.js
var CABINET_QUERY_PARAMS_FOR_LIGHTBOX_PRIMARY = "?preset=3:2-md&presetScale=3/4service=lightbox&dpr=1", CABINET_QUERY_PARAMS_LIGHTBOX_CAROUSEL = "?preset=3:2-sm&presetScale=1/8&service=lightbox&dpr=1";


// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/teams/marketplace/components/Lightbox/Lightbox.js














var Lightbox = function(param) {
    var analyticsName = param.analyticsName, photoUrls = param.photoUrls, isOpen = param.isOpen, handleClose = param.handleClose, mobileTitle = param.mobileTitle, footer = param.footer, selectedPhotoIndex = param.selectedPhotoIndex;
    var ref = (0,useWindowDimensions/* default */.Z)(), windowWidth = ref.width, windowHeight = ref.height, photoRefs = (0,react.useRef)([]), ref1 = (0,react.useState)(selectedPhotoIndex || 0), primaryPhotoIndex = ref1[0], setPrimaryPhotoIndex = ref1[1], containerRef = (0,react.useRef)(null), ref2 = (0,react.useState)(null), panResponder = ref2[0], setPanResponder = ref2[1], ref3 = (0,react.useState)(!1), isLandscape = ref3[0], setIsLandscape = ref3[1], offsetX = (0,react.useRef)(new Animated/* default.Value */.Z.Value(0)).current, currentOffset = (0,react.useRef)(0), carouselRef = (0,react.useRef)(null), lastNavigationSource = (0,react.useRef)(null), primaryPhotoRefs = (0,react.useRef)(photoUrls.map(function(_) {
        return /*#__PURE__*/ (0,react.createRef)();
    })), handleOnPress = function(index) {
        setPrimaryPhotoIndex(index);
    };
    (0,react.useEffect)(function() {
        cjs.isClient && Math.abs(window.orientation) === 90 && setIsLandscape(!0);
    }, []), (0,react.useEffect)(function() {
        selectedPhotoIndex != null && setPrimaryPhotoIndex(selectedPhotoIndex);
    }, [
        selectedPhotoIndex
    ]), (0,react.useEffect)(function() {
        var ref;
        var photoItem = photoRefs.current[primaryPhotoIndex];
        photoItem === null || photoItem === void 0 ? void 0 : photoItem.scrollIntoView({
            behavior: "smooth",
            block: "nearest"
        }), ((ref = lastNavigationSource.current) === null || ref === void 0 ? void 0 : ref.source) === "keyboard" && !lastNavigationSource.current.keyboardActivated && (photoItem === null || photoItem === void 0 ? void 0 : photoItem.focus());
    }, [
        primaryPhotoIndex
    ]);
    var handleRight = (0,react.useCallback)(function(source) {
        var keyboardActivated = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
        var newIndex = primaryPhotoIndex + 1;
        return newIndex >= photoUrls.length && (newIndex = 0), setPrimaryPhotoIndex(newIndex), {
            source: source,
            keyboardActivated: keyboardActivated
        };
    }, [
        primaryPhotoIndex,
        photoUrls.length
    ]), handleLeft = (0,react.useCallback)(function(source) {
        var keyboardActivated = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
        var newIndex = primaryPhotoIndex - 1;
        return newIndex < 0 && (newIndex = photoUrls.length - 1), setPrimaryPhotoIndex(newIndex), {
            source: source,
            keyboardActivated: keyboardActivated
        };
    }, [
        primaryPhotoIndex,
        photoUrls.length
    ]);
    (0,react.useEffect)(function() {
        var responder = PanResponder/* default.create */.Z.create({
            onMoveShouldSetPanResponder: function() {
                return !0;
            },
            onPanResponderGrant: function() {
                offsetX.setValue(currentOffset.current);
            },
            onPanResponderMove: function(evt, gestureState) {
                var touches = evt.nativeEvent.touches;
                touches && touches.length < 2 && offsetX.setValue(currentOffset.current + gestureState.dx);
            },
            onPanResponderRelease: function(evt, gestureState) {
                var currentImageIndex = primaryPhotoIndex, threshold = windowWidth / 7;
                var newIndex = currentImageIndex;
                gestureState.dx > threshold ? newIndex = currentImageIndex > 0 ? currentImageIndex - 1 : currentImageIndex : gestureState.dx < -threshold && (newIndex = currentImageIndex < photoUrls.length - 1 ? currentImageIndex + 1 : currentImageIndex), newIndex !== currentImageIndex ? Animated/* default.timing */.Z.timing(offsetX, {
                    toValue: -newIndex * windowWidth,
                    duration: 300,
                    easing: Easing/* default.linear */.Z.linear,
                    useNativeDriver: !cjs.isWeb
                }).start(function() {
                    currentOffset.current = -newIndex * windowWidth, setPrimaryPhotoIndex(newIndex), exports_AccessibilityInfo.announceForAccessibility("Image ".concat(newIndex + 1));
                }) : Animated/* default.spring */.Z.spring(offsetX, {
                    toValue: currentOffset.current,
                    useNativeDriver: !cjs.isWeb
                }).start();
            }
        });
        setPanResponder(responder);
    }, [
        windowWidth,
        offsetX,
        primaryPhotoIndex,
        photoUrls.length
    ]), (0,react.useEffect)(function() {
        offsetX.setValue(-primaryPhotoIndex * windowWidth), currentOffset.current = -primaryPhotoIndex * windowWidth;
    }, [
        windowWidth,
        offsetX,
        primaryPhotoIndex
    ]);
    var handleKeyDownEvents = (0,react.useCallback)(function(e) {
        (0,_instanceof/* default */.Z)(e, KeyboardEvent) && (e.key === "ArrowRight" ? lastNavigationSource.current = handleRight("keyboard") : e.key === "ArrowLeft" ? lastNavigationSource.current = handleLeft("keyboard") : e.key === "Escape" && handleClose());
    }, [
        handleClose,
        handleLeft,
        handleRight
    ]), handleChevronPress = (0,react.useCallback)(function(direction) {
        return function(event) {
            var keyboardActivated = !1;
            "nativeEvent" in event && (0,_instanceof/* default */.Z)(event.nativeEvent, KeyboardEvent) ? keyboardActivated = !0 : event.type === "click" && (keyboardActivated = !1), lastNavigationSource.current = direction === "left" ? handleLeft("button", keyboardActivated) : handleRight("button", keyboardActivated);
        };
    }, [
        handleLeft,
        handleRight
    ]);
    (0,react.useEffect)(function() {
        return cjs.isWeb && document.addEventListener("keydown", handleKeyDownEvents), function() {
            cjs.isWeb && document.removeEventListener("keydown", handleKeyDownEvents);
        };
    }, [
        handleKeyDownEvents
    ]), (0,react.useEffect)(function() {
        windowWidth > windowHeight ? setIsLandscape(!0) : setIsLandscape(!1);
    }, [
        windowHeight,
        windowWidth
    ]);
    var renderImages = function() {
        return photoUrls.map(function(photo, index) {
            return index >= primaryPhotoIndex - 2 && index <= primaryPhotoIndex + 2 ? /* @__PURE__ */ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                width: windowWidth,
                height: "100%",
                "aria-hidden": index !== primaryPhotoIndex,
                flexGrow: 1,
                children: /* @__PURE__ */ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                    alt: "Current primary photograph in lightbox",
                    source: {
                        uri: "".concat(photoUrls[index]).concat(CABINET_QUERY_PARAMS_FOR_LIGHTBOX_PRIMARY)
                    },
                    resizeMode: "contain",
                    height: "100%",
                    width: "100%",
                    mb: "$10x",
                    ref: primaryPhotoRefs.current[index],
                    enableZoom: !0
                })
            }, "main-photos-".concat(index)) : /* @__PURE__ */ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                width: windowWidth,
                height: "100%",
                "aria-hidden": !0
            }, "main-photo-empty-".concat(index));
        });
    }, ref4 = (0,cjs.useMedia)(), largerThanSM = ref4.largerThanSM, smallerThanMD = ref4.smallerThanMD;
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(Dialog/* Dialog */.Vq, {
        modal: !0,
        open: isOpen,
        children: /* @__PURE__ */ (0,jsx_runtime.jsxs)(Dialog/* Dialog.Portal */.Vq.Portal, {
            children: [
                /* @__PURE__ */ (0,jsx_runtime.jsx)(Dialog/* Dialog.Overlay */.Vq.Overlay, {
                    animation: "accelerateDecelerateFastest",
                    opacity: 0.5,
                    enterStyle: {
                        opacity: 0
                    },
                    exitStyle: {
                        opacity: 0
                    }
                }, "overlay"),
                /* @__PURE__ */ (0,jsx_runtime.jsxs)(Dialog/* Dialog.Content */.Vq.Content, {
                    bordered: !0,
                    elevate: !0,
                    animateOnly: [
                        "transform",
                        "opacity"
                    ],
                    animation: [
                        "accelerateDecelerateFastest",
                        {
                            opacity: {
                                overshootClamping: !0
                            }
                        }
                    ],
                    enterStyle: {
                        x: 0,
                        y: -20,
                        opacity: 0,
                        scale: 0.9
                    },
                    exitStyle: {
                        x: 0,
                        y: 10,
                        opacity: 0,
                        scale: 0.95
                    },
                    height: "100%",
                    width: "100%",
                    backgroundColor: "$backgroundInversePureBlack",
                    flexDirection: "column",
                    $smallerThanMD: {
                        justifyContent: "center"
                    },
                    px: 0,
                    focusStyle: {
                        borderColor: "$backgroundInversePureBlack"
                    },
                    children: [
                        /* @__PURE__ */ (0,jsx_runtime.jsxs)(Dialog/* Dialog.Title */.Vq.Title, {
                            flexDirection: "row",
                            justifyContent: "space-between",
                            onKeyDown: handleKeyDownEvents,
                            $smallerThanMD: {
                                flexDirection: "row-reverse"
                            },
                            width: "100%",
                            "data-testid": "lightbox-content",
                            mt: isLandscape && !cjs.isWeb ? "$20x" : null,
                            $largerThanSM: {
                                px: "$20x"
                            },
                            px: "$10x",
                            display: "flex",
                            alignItems: "center",
                            mb: "$8x",
                            children: [
                                /* @__PURE__ */ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                                    tag: "span",
                                    typography: "$bodyMedium",
                                    color: "$contentInversePrimary",
                                    "data-testid": "photo-count",
                                    width: 64,
                                    $largerThanSM: {
                                        textAlign: "left"
                                    },
                                    textAlign: "right",
                                    children: [
                                        primaryPhotoIndex + 1,
                                        " of ",
                                        photoUrls.length
                                    ]
                                }),
                                /* @__PURE__ */ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                                    flex: 1,
                                    justifyContent: "center",
                                    children: smallerThanMD && mobileTitle
                                }),
                                /* @__PURE__ */ (0,jsx_runtime.jsx)(Dialog/* Dialog.Close */.Vq.Close, {
                                    asChild: !0,
                                    children: /* @__PURE__ */ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
                                        $smallerThanMD: {
                                            width: "$64x"
                                        },
                                        children: [
                                            /* @__PURE__ */ (0,jsx_runtime.jsx)(IconButton/* CloseButton */.PZ, {
                                                analyticsName: "desktop-".concat(analyticsName, "-close"),
                                                onPress: handleClose,
                                                size: "medium",
                                                variant: "inverse",
                                                $smallerThanMD: {
                                                    display: "none"
                                                },
                                                $largerThanSM: {
                                                    display: "flex"
                                                }
                                            }),
                                            /* @__PURE__ */ (0,jsx_runtime.jsx)(IconButton/* ChevronBackButton */.jd, {
                                                analyticsName: "mobile-".concat(analyticsName, "-close"),
                                                onPress: handleClose,
                                                size: "medium",
                                                variant: "inverse",
                                                $smallerThanMD: {
                                                    display: "flex"
                                                },
                                                $largerThanSM: {
                                                    display: "none"
                                                }
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /* @__PURE__ */ (0,jsx_runtime.jsx)(cjs.View, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            width: "100%"
                        }, panResponder && panResponder.panHandlers), {
                            ref: carouselRef,
                            "aria-label": "Image Carousel, showing image ".concat(primaryPhotoIndex + 1, " of ").concat(photoUrls.length),
                            flex: 1,
                            children: /* @__PURE__ */ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
                                ref: containerRef,
                                height: "100%",
                                justifyContent: "center",
                                alignContent: "center",
                                aspectRatio: "3/2",
                                "data-testid": "lightbox-swipeable",
                                children: [
                                    /* @__PURE__ */ (0,jsx_runtime.jsx)(Animated/* default.View */.Z.View, {
                                        style: {
                                            flexDirection: "row",
                                            width: windowWidth * photoUrls.length,
                                            transform: [
                                                {
                                                    translateX: offsetX
                                                }
                                            ],
                                            marginBottom: 5,
                                            flex: 1
                                        },
                                        children: renderImages()
                                    }),
                                    cjs.isWeb && /* @__PURE__ */ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /* @__PURE__ */ (0,jsx_runtime.jsx)(IconButton/* ChevronBackButton */.jd, {
                                                "data-testid": "lightbox-back-button",
                                                analyticsName: "".concat(analyticsName, "-lightbox-back-button"),
                                                size: "medium",
                                                $largerThanSM: {
                                                    frameSize: "large",
                                                    left: 32
                                                },
                                                $smallerThanMD: {
                                                    display: "none"
                                                },
                                                variant: "inverse",
                                                onPress: handleChevronPress("left"),
                                                position: "absolute",
                                                left: 0,
                                                ml: "$5x",
                                                top: "40%",
                                                display: "flex"
                                            }),
                                            /* @__PURE__ */ (0,jsx_runtime.jsx)(IconButton/* ChevronForwardButton */.bB, {
                                                "data-testid": "lightbox-forward-button",
                                                analyticsName: "".concat(analyticsName, "-lightbox-forward-button"),
                                                size: "medium",
                                                onPress: handleChevronPress("right"),
                                                $largerThanSM: {
                                                    frameSize: "large",
                                                    right: 32
                                                },
                                                $smallerThanMD: {
                                                    display: "none"
                                                },
                                                variant: "inverse",
                                                position: "absolute",
                                                right: 0,
                                                mr: "$5x",
                                                top: "40%",
                                                display: "flex"
                                            })
                                        ]
                                    }),
                                    largerThanSM && cjs.isWeb && /* @__PURE__ */ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                                        children: /* @__PURE__ */ (0,jsx_runtime.jsx)(ScrollView/* default */.Z, {
                                            horizontal: !0,
                                            showsHorizontalScrollIndicator: !1,
                                            children: photoUrls === null || photoUrls === void 0 ? void 0 : photoUrls.map(function(photo, index) {
                                                return /* @__PURE__ */ (0,jsx_runtime.jsx)(CarouselPhoto, {
                                                    handleOnPress: handleOnPress,
                                                    photoUrl: photo,
                                                    index: index,
                                                    primaryPhotoIndex: primaryPhotoIndex,
                                                    isPrimary: index === primaryPhotoIndex,
                                                    photoRefs: photoRefs
                                                }, index);
                                            })
                                        })
                                    }),
                                    cjs.isWeb && largerThanSM && /* @__PURE__ */ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                                        flexDirection: "row",
                                        justifyContent: "space-between",
                                        p: "$8x",
                                        width: "100%",
                                        children: footer
                                    })
                                ]
                            })
                        }))
                    ]
                }, "content")
            ]
        })
    });
};
Lightbox.displayName = "Lightbox";
var CarouselPhoto = function(param) {
    var handleOnPress = param.handleOnPress, photoUrl = param.photoUrl, index = param.index, isPrimary = param.isPrimary, photoRefs = param.photoRefs;
    var onPress = (0,react.useCallback)(function() {
        handleOnPress(index);
    }, [
        handleOnPress,
        index
    ]), IMG_CONTAINER_HEIGHT = 65, IMG_CONTAINER_WIDTH = 99, CONTAINER_HEIGHT = 73, photo = "".concat(photoUrl).concat(CABINET_QUERY_PARAMS_LIGHTBOX_CAROUSEL), handleRef = function(el) {
        el && photoRefs.current && (photoRefs.current[index] = el);
    };
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(PressableBox/* PressableBox */.K, {
        analyticsName: "lightbox-photo-item-".concat(index),
        "aria-label": "Lightbox carousel photo ".concat(index + 1),
        borderColor: isPrimary ? "$borderTertiary" : "$backgroundInversePureBlack",
        borderWidth: "$2x",
        height: CONTAINER_HEIGHT,
        $smallerThanMD: {
            display: "none"
        },
        onPress: onPress,
        "data-testid": "photo-item-".concat(index),
        px: 0,
        ref: handleRef,
        children: /* @__PURE__ */ (0,jsx_runtime.jsx)(Image/* Image */.E, {
            alt: "carousel photograph ".concat(index + 1),
            source: {
                uri: photo
            },
            resizeMode: "cover",
            height: IMG_CONTAINER_HEIGHT,
            width: IMG_CONTAINER_WIDTH
        })
    });
};



/***/ }),

/***/ 207609:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 127825:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getRailsEnv = void 0;
exports.isRailsEnv = isRailsEnv;
exports.assertRailEnvOrThrow = assertRailEnvOrThrow;
var envs = ['production', 'staging', 'qa', 'development', 'test'];
function isRailsEnv(env) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return envs.includes(env);
}
function assertRailEnvOrThrow(env) {
    if (isRailsEnv(env)) {
        return env;
    }
    throw new Error("".concat(env, " is not a valid RailsEnv"));
}
var getRailsEnv = function () {
    var _a, _b, _c, _d;
    if (typeof window === 'undefined' || typeof document === 'undefined') {
        return 'development';
    }
    var hostname = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname;
    if (hostname === undefined) {
        return 'development';
    }
    var port = (_b = window === null || window === void 0 ? void 0 : window.location) === null || _b === void 0 ? void 0 : _b.port;
    var locationHasPort = port && port !== '';
    var onLocalhost = hostname === 'localhost';
    var onNgrok = hostname.includes('.ngrok.io');
    var onXipIO = hostname.includes('.xip.io');
    var inAndroidEmulator = hostname.includes('10.0.2.2');
    var inDevelopment = (onLocalhost && locationHasPort) || onNgrok || onXipIO || inAndroidEmulator;
    if (inDevelopment) {
        return 'development';
    }
    // In Rails CI, tests my be on a random port
    var inRailsCI = hostname === '127.0.0.1';
    // on localhost without a port corresponds to test environment
    if (inRailsCI || onLocalhost) {
        return 'test';
    }
    var onStagingManagedDomain = hostname.includes('-staging.managed.services.opendoor.com') ||
        hostname.includes('-staging.ops.opendoor.com') ||
        hostname.includes('-staging.opendoor.com');
    var onSimplersell = hostname.includes('.simplersell.com');
    var onODMortgage = hostname.includes('.odmortgage.com');
    var inStaging = onStagingManagedDomain || onSimplersell || onODMortgage;
    var inProduction = hostname.includes('.opendoor.com') && !hostname.includes('-staging');
    var inProdOrStaging = inStaging || inProduction;
    var onQADomain = hostname.includes('-qa-');
    var hasQACookie = ((_c = document === null || document === void 0 ? void 0 : document.cookie) === null || _c === void 0 ? void 0 : _c.includes('qa=')) && ((_d = document === null || document === void 0 ? void 0 : document.cookie) === null || _d === void 0 ? void 0 : _d.includes('qa_env='));
    // most QA usage will be on a staging domain (.e.g `demo.simplersell.com`) with appropriate
    // cookies set
    var inQA = onQADomain || (inProdOrStaging && hasQACookie);
    if (inQA) {
        return 'qa';
    }
    else if (inStaging) {
        return 'staging';
    }
    else if (inProduction) {
        return 'production';
    }
    // default case
    return 'development';
};
exports.getRailsEnv = getRailsEnv;


/***/ }),

/***/ 61442:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(382526);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(141817);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(932165);
/* harmony import */ var core_js_modules_es_symbol_to_primitive_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(696649);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57327);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(489554);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(491038);
/* harmony import */ var core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(682772);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(66992);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(747042);
/* harmony import */ var core_js_modules_es_date_to_primitive_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(396078);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(968309);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(209653);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(319601);
/* harmony import */ var core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(833321);
/* harmony import */ var core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(369070);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(438880);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(749337);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(447941);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(241539);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(974916);
/* harmony import */ var core_js_modules_es_regexp_test_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(477601);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(339714);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(978783);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(454747);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(333948);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(667294);
/* harmony import */ var _chakra_ui_hooks__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(897375);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(624614);
/* harmony import */ var _hooks_useObservabilitySafe_mjs__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(298352);
/* harmony import */ var _system_bricks_types_mjs__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(626153);
/* harmony import */ var _system_utils_index_mjs__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(848189);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }


























var _excluded = ["aspectRatio", "fallbackSrc", "loading"],
  _excluded2 = ["analyticsName", "trackImpression"],
  _excluded3 = ["analyticsName"];
function cov_292sh6sq8e() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Image/Image.tsx";
  var hash = "c9a8c2c0a69bd9c54bbf29fe2d221e94190246f7";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Image/Image.tsx",
    statementMap: {
      "0": {
        start: {
          line: 48,
          column: 18
        },
        end: {
          line: 73,
          column: 1
        }
      },
      "1": {
        start: {
          line: 50,
          column: 19
        },
        end: {
          line: 50,
          column: 49
        }
      },
      "2": {
        start: {
          line: 51,
          column: 21
        },
        end: {
          line: 51,
          column: 70
        }
      },
      "3": {
        start: {
          line: 52,
          column: 26
        },
        end: {
          line: 52,
          column: 45
        }
      },
      "4": {
        start: {
          line: 54,
          column: 19
        },
        end: {
          line: 54,
          column: 45
        }
      },
      "5": {
        start: {
          line: 55,
          column: 4
        },
        end: {
          line: 59,
          column: 14
        }
      },
      "6": {
        start: {
          line: 58,
          column: 6
        },
        end: {
          line: 58,
          column: 31
        }
      },
      "7": {
        start: {
          line: 61,
          column: 4
        },
        end: {
          line: 71,
          column: 6
        }
      },
      "8": {
        start: {
          line: 63,
          column: 23
        },
        end: {
          line: 63,
          column: 42
        }
      },
      "9": {
        start: {
          line: 75,
          column: 26
        },
        end: {
          line: 80,
          column: 1
        }
      },
      "10": {
        start: {
          line: 77,
          column: 22
        },
        end: {
          line: 77,
          column: 95
        }
      },
      "11": {
        start: {
          line: 78,
          column: 4
        },
        end: {
          line: 78,
          column: 71
        }
      },
      "12": {
        start: {
          line: 170,
          column: 14
        },
        end: {
          line: 176,
          column: 2
        }
      },
      "13": {
        start: {
          line: 171,
          column: 2
        },
        end: {
          line: 173,
          column: 3
        }
      },
      "14": {
        start: {
          line: 172,
          column: 4
        },
        end: {
          line: 172,
          column: 100
        }
      },
      "15": {
        start: {
          line: 175,
          column: 2
        },
        end: {
          line: 175,
          column: 44
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 49,
            column: 2
          },
          end: {
            line: 49,
            column: 3
          }
        },
        loc: {
          start: {
            line: 49,
            column: 60
          },
          end: {
            line: 72,
            column: 3
          }
        },
        line: 49
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 55,
            column: 14
          },
          end: {
            line: 55,
            column: 15
          }
        },
        loc: {
          start: {
            line: 55,
            column: 20
          },
          end: {
            line: 59,
            column: 5
          }
        },
        line: 55
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 63,
            column: 17
          },
          end: {
            line: 63,
            column: 18
          }
        },
        loc: {
          start: {
            line: 63,
            column: 23
          },
          end: {
            line: 63,
            column: 42
          }
        },
        line: 63
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 76,
            column: 2
          },
          end: {
            line: 76,
            column: 3
          }
        },
        loc: {
          start: {
            line: 76,
            column: 57
          },
          end: {
            line: 79,
            column: 3
          }
        },
        line: 76
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 170,
            column: 44
          },
          end: {
            line: 170,
            column: 45
          }
        },
        loc: {
          start: {
            line: 170,
            column: 82
          },
          end: {
            line: 176,
            column: 1
          }
        },
        line: 170
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 51,
            column: 47
          },
          end: {
            line: 51,
            column: 68
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 51,
            column: 47
          },
          end: {
            line: 51,
            column: 58
          }
        }, {
          start: {
            line: 51,
            column: 62
          },
          end: {
            line: 51,
            column: 68
          }
        }],
        line: 51
      },
      "1": {
        loc: {
          start: {
            line: 171,
            column: 2
          },
          end: {
            line: 173,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 171,
            column: 2
          },
          end: {
            line: 173,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 171
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "c9a8c2c0a69bd9c54bbf29fe2d221e94190246f7"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_292sh6sq8e = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_292sh6sq8e();
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }







/**
 * Set of allowed aspect ratios defined by design.
 */

/**
 * NOTE ON METRIC TRACKING: Image is set up to track impression events
 * It will only track impression events if:
 *  1) a non-empty analyticsName is passed down
 *  2) the entirety of the image enters the viewport
 */

var BaseImage = (cov_292sh6sq8e().s[0]++, (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_27__/* .forwardRef */ .Gp)(function (_ref, ref) {
  var aspectRatio = _ref.aspectRatio,
    fallbackSrc = _ref.fallbackSrc,
    loading = _ref.loading,
    props = _objectWithoutProperties(_ref, _excluded);
  cov_292sh6sq8e().f[0]++;
  var styles = (cov_292sh6sq8e().s[1]++, (0,_system_utils_index_mjs__WEBPACK_IMPORTED_MODULE_28__/* .useStyleConfig */ .mq)('Image', props));
  var imgStyle = (cov_292sh6sq8e().s[2]++, _objectSpread(_objectSpread({}, styles), {}, {
    aspectRatio: (cov_292sh6sq8e().b[0][0]++, aspectRatio) || (cov_292sh6sq8e().b[0][1]++, 'auto')
  }));
  var _ref2 = (cov_292sh6sq8e().s[3]++, (0,react__WEBPACK_IMPORTED_MODULE_26__.useState)(props.src)),
    _ref3 = _slicedToArray(_ref2, 2),
    src = _ref3[0],
    setSrc = _ref3[1];
  var imgRef = (cov_292sh6sq8e().s[4]++, (0,react__WEBPACK_IMPORTED_MODULE_26__.useRef)());
  cov_292sh6sq8e().s[5]++;
  (0,react__WEBPACK_IMPORTED_MODULE_26__.useEffect)(function () {
    cov_292sh6sq8e().f[1]++;
    cov_292sh6sq8e().s[6]++;
    // Update ref src if onError fires during hydration - see bug:
    // https://github.com/facebook/react/issues/15446#issuecomment-484709466
    imgRef.current.src = src;
  }, [src]);
  cov_292sh6sq8e().s[7]++;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_26__.createElement(_system_bricks_types_mjs__WEBPACK_IMPORTED_MODULE_29__/* .bricks.img */ .G.img, _extends({
    onError: function onError() {
      cov_292sh6sq8e().f[2]++;
      cov_292sh6sq8e().s[8]++;
      return setSrc(fallbackSrc);
    },
    ref: (0,_chakra_ui_hooks__WEBPACK_IMPORTED_MODULE_30__/* .useMergeRefs */ .qq)(imgRef, ref)
    // __css has a lower priority than sx
    ,
    __css: imgStyle,
    loading: loading
  }, props, {
    src: src
  }));
}));
var ImageWithTracking = (cov_292sh6sq8e().s[9]++, (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_27__/* .forwardRef */ .Gp)(function (_ref4, ref) {
  var analyticsName = _ref4.analyticsName,
    trackImpression = _ref4.trackImpression,
    props = _objectWithoutProperties(_ref4, _excluded2);
  cov_292sh6sq8e().f[3]++;
  var inViewRef = (cov_292sh6sq8e().s[10]++, (0,_hooks_useObservabilitySafe_mjs__WEBPACK_IMPORTED_MODULE_31__/* .useTrackComponentInView */ .O)('imageViewEvent', trackImpression, analyticsName));
  cov_292sh6sq8e().s[11]++;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_26__.createElement(BaseImage, _extends({
    ref: (0,_chakra_ui_hooks__WEBPACK_IMPORTED_MODULE_30__/* .useMergeRefs */ .qq)(inViewRef, ref)
  }, props));
}));

/**
 * An image view displays a single image — or in some cases, an animated
 * sequence of images — on a transparent or opaque background.
 *
 * Accessibility
 *
 *
 * -----------------
 *
 * Fallback (alternate) text to display when the image specified by the element
 * is not loaded. The `alt` attribute is officially mandatory; it's meant to
 * always be specified. If the image doesn't require a fallback (such as for an
 * image which is decorative or an advisory icon of minimal importance), you may
 * specify an empty string (""). See
 * [https://developer.mozilla.org/en-US/docs/Web/API/HTMLImageElement/alt](https://developer.mozilla.org/en-US/docs/Web/API/HTMLImageElement/alt).
 *
 * ###
 *
 * Guidelines for `alt` tags:
 *
 * 1.  For both images and icons, if it's merely decorative, you don't need to
 * write `alt` text. Pass an empty string in these cases. You only need to add
 * it for ones that provide information or function.
 *
 * 2.  Highlight key things. You don't need to go into extreme detail.
 *
 * *   What's most noticeable?
 *
 * *   Who's in it?
 *
 * *   What are they doing?
 *
 * *   Where are they?
 *
 * 3.  You don't need to actually write "Image of" or "Picture of." That should
 * get auto-included by screen readers.
 *
 * 4.  For icons that provide function, you can include action/target here, too.
 * Some examples:
 *
 * *   Chat icon = Chat with an Opendoor Expert
 *
 * *   Menu icon = Open Menu / Open Settings
 *
 * *   Search icon = Search for homes
 *
 * *   Plus icon = Add person
 *
 * 5.  See o/glossary to verify that your labels match Opendoor's guidelines for
 * copy blocks.
 *
 *
 * ###
 *
 * ✅ Pass
 *
 * <Image src={homePhotoUrl} alt="The home at 125 W Muriel Dr, Phoenix, AZ
 * 85023" />
 *
 *
 * ###
 *
 * 🛑 Fail
 *
 * <Image src={homePhotoUrl} />
 *
 *
 * Analytics
 *
 *
 * -------------
 *
 * `Image` is set up to track impression events. It will only track impression
 * events if:
 *
 * 1.  a non-empty `analyticsName` is passed down (convention:
 * {appName}-{imageName})
 *
 * 2.  passing `trackImpression={true}` Image impression events will only be
 * tracked the first time that the image enters the viewport
 *
 *
 * Events will be sent to the journey service and will end up in the
 * corresponding tables (e.g.
 * journey\_service\_production.platform\_image\_view\_event for image
 * impression events). For more information on tracking please refer
 * here:[https://opendoor.atlassian.net/wiki/spaces/CONSUMER/blog/2023/05/10/2304737293/Bricks+Events+Update](https://opendoor.atlassian.net/wiki/spaces/CONSUMER/blog/2023/05/10/2304737293/Bricks+Events+Update)
 */
var Image = (cov_292sh6sq8e().s[12]++, (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_27__/* .forwardRef */ .Gp)(function (_ref5, ref) {
  var analyticsName = _ref5.analyticsName,
    props = _objectWithoutProperties(_ref5, _excluded3);
  cov_292sh6sq8e().f[4]++;
  cov_292sh6sq8e().s[13]++;
  if (analyticsName) {
    cov_292sh6sq8e().b[1][0]++;
    cov_292sh6sq8e().s[14]++;
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_26__.createElement(ImageWithTracking, _extends({
      alt: props.alt,
      analyticsName: analyticsName,
      ref: ref
    }, props));
  } else {
    cov_292sh6sq8e().b[1][1]++;
  }
  cov_292sh6sq8e().s[15]++;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_26__.createElement(BaseImage, _extends({
    ref: ref
  }, props));
}));
/* harmony default export */ __webpack_exports__["Z"] = (Image);

/***/ }),

/***/ 796832:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "G": function() { return /* binding */ Themed; }
});

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__(382526);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.index-of.js
var es_array_index_of = __webpack_require__(682772);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.assign.js
var es_object_assign = __webpack_require__(319601);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__(447941);
// EXTERNAL MODULE: ./node_modules/lodash/mergeWith.js
var mergeWith = __webpack_require__(730236);
// EXTERNAL MODULE: ./node_modules/lodash/cloneDeep.js
var cloneDeep = __webpack_require__(150361);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/chakra-ui-system.esm.js + 6 modules
var chakra_ui_system_esm = __webpack_require__(624614);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/complex/DatePicker/ReactDatesStyles.mjs
var ReactDatesStyles = __webpack_require__(694339);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/Icon/Spritesheet.mjs + 138 modules
var Spritesheet = __webpack_require__(409526);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(370917);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/styles/FontFace.mjs
function cov_28e88htlke() {
  var path = "/__w/code/code/js/packages/bricks/src/styles/FontFace.tsx";
  var hash = "39acc2af239b40568310f2c203694ecb7cea6bc4";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/styles/FontFace.tsx",
    statementMap: {
      "0": {
        start: {
          line: 10,
          column: 34
        },
        end: {
          line: 100,
          column: 1
        }
      },
      "1": {
        start: {
          line: 11,
          column: 2
        },
        end: {
          line: 99,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 10,
            column: 34
          },
          end: {
            line: 10,
            column: 35
          }
        },
        loc: {
          start: {
            line: 11,
            column: 2
          },
          end: {
            line: 99,
            column: 4
          }
        },
        line: 11
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0
    },
    f: {
      "0": 0
    },
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "39acc2af239b40568310f2c203694ecb7cea6bc4"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_28e88htlke = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_28e88htlke();



/**
 * Globally defined font definitions for the theme.
 * Currently font are also defined in packages/primer/stylesheets/market/variables.less -
 * this will ultimately replace the less file.
 */
cov_28e88htlke().s[0]++;
var FontFace = function FontFace() {
  cov_28e88htlke().f[0]++;
  cov_28e88htlke().s[1]++;
  return /*#__PURE__*/react.createElement(emotion_react_browser_esm/* Global */.xB, {
    styles: "\n      @font-face {\n        font-family: 'Graphik';\n        font-style: normal;\n        font-weight: 400;\n        src: local('Graphik-Regular'), local('Graphik'),\n          url('https://cdn.opendoor.com/fonts/Graphik-Regular-Web.woff2') format('woff2');\n      }\n      @font-face {\n        font-family: 'Graphik';\n        font-style: normal;\n        font-weight: 500;\n        src: local('Graphik-Medium'), local('Graphik'),\n          url('https://cdn.opendoor.com/fonts/Graphik-Medium-Web.woff2') format('woff2');\n      }\n      @font-face {\n        font-family: 'Graphik';\n        font-style: normal;\n        font-weight: 600;\n        src: local('Graphik-Semibold'), local('Graphik'),\n          url('https://cdn.opendoor.com/fonts/Graphik-Semibold-Web.woff2') format('woff2');\n      }\n      @font-face {\n        font-family: 'Graphik';\n        font-style: normal;\n        font-weight: 800;\n        src: local('Graphik-Bold'), local('Graphik'),\n          url('https://cdn.opendoor.com/fonts/Graphik-Bold-Web.woff2') format('woff2');\n      }\n      @font-face {\n        font-family: 'Noto-Mono';\n        font-style: normal;\n        font-weight: 400;\n        src: local('Noto-Mono-Regular'), local('Noto-Mono'),\n          url('https://cdn.opendoor.com/fonts/NotoMono-Regular-Web.woff') format('woff');\n      }\n      @font-face {\n        font-family: 'Publico';\n        font-style: normal;\n        font-weight: 400;\n        src: local('Publico-Regular'), local('Publico'),\n          url('https://cdn.opendoor.com/fonts/PublicoHeadline-Roman-Web.woff2') format('woff2');\n      }\n      @font-face {\n        font-family: 'Publico';\n        font-weight: 500;\n        src: local('Publico-Medium'), local('Publico'),\n          url('https://cdn.opendoor.com/fonts/PublicoHeadline-Medium-Web.woff2') format('woff2');\n      }\n      @font-face {\n        font-family: 'Publico';\n        font-style: normal;\n        font-weight: 600;\n        src: local('Publico-Bold'), local('Publico'),\n          url('https://cdn.opendoor.com/fonts/PublicoHeadline-Bold-Web.woff2') format('woff2');\n      }\n      @font-face {\n        font-family: 'Publico, serif';\n        font-style: normal;\n        font-weight: 400;\n        src: local('Publico-Regular'), local('Publico'),\n          url('https://cdn.opendoor.com/fonts/PublicoHeadline-Roman-Web.woff2') format('woff2');\n      }\n      @font-face {\n        font-family: 'Publico, serif';\n        font-weight: 500;\n        src: local('Publico-Medium'), local('Publico'),\n          url('https://cdn.opendoor.com/fonts/PublicoHeadline-Medium-Web.woff2') format('woff2');\n      }\n      @font-face {\n        font-family: 'Publico, serif';\n        font-style: normal;\n        font-weight: 600;\n        src: local('Publico-Bold'), local('Publico'),\n          url('https://cdn.opendoor.com/fonts/PublicoHeadline-Bold-Web.woff2') format('woff2');\n      }\n\n      body,\n      input,\n      select {\n        text-rendering: optimizeLegibility;\n\n        // Base font size for all breakpoints\n        font: 400 16px / 1.7 'Graphik', sans-serif;\n        color: var(--colors-neutrals100);\n      }\n    "
  });
};
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/styles/Reset.mjs
var Reset = __webpack_require__(875590);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/theme/index.mjs + 2 modules
var es_theme = __webpack_require__(691567);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/theme/ThemeOverrideExpiredBanner.mjs + 3 modules
var ThemeOverrideExpiredBanner = __webpack_require__(633651);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/theme/ODTheme.mjs






var _excluded = ["children"];
function cov_2ijo9jc43y() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/ODTheme.tsx";
  var hash = "706ff77feed03f8de73212117c1fb36840db55a4";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/ODTheme.tsx",
    statementMap: {
      "0": {
        start: {
          line: 16,
          column: 45
        },
        end: {
          line: 42,
          column: 1
        }
      },
      "1": {
        start: {
          line: 18,
          column: 24
        },
        end: {
          line: 18,
          column: 76
        }
      },
      "2": {
        start: {
          line: 19,
          column: 14
        },
        end: {
          line: 19,
          column: 48
        }
      },
      "3": {
        start: {
          line: 22,
          column: 2
        },
        end: {
          line: 25,
          column: 3
        }
      },
      "4": {
        start: {
          line: 23,
          column: 4
        },
        end: {
          line: 23,
          column: 29
        }
      },
      "5": {
        start: {
          line: 24,
          column: 4
        },
        end: {
          line: 24,
          column: 38
        }
      },
      "6": {
        start: {
          line: 27,
          column: 2
        },
        end: {
          line: 41,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 16,
            column: 45
          },
          end: {
            line: 16,
            column: 46
          }
        },
        loc: {
          start: {
            line: 16,
            column: 73
          },
          end: {
            line: 42,
            column: 1
          }
        },
        line: 16
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 18,
            column: 24
          },
          end: {
            line: 18,
            column: 76
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 18,
            column: 47
          },
          end: {
            line: 18,
            column: 62
          }
        }, {
          start: {
            line: 18,
            column: 65
          },
          end: {
            line: 18,
            column: 76
          }
        }],
        line: 18
      },
      "1": {
        loc: {
          start: {
            line: 19,
            column: 24
          },
          end: {
            line: 19,
            column: 47
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 19,
            column: 24
          },
          end: {
            line: 19,
            column: 37
          }
        }, {
          start: {
            line: 19,
            column: 41
          },
          end: {
            line: 19,
            column: 47
          }
        }],
        line: 19
      },
      "2": {
        loc: {
          start: {
            line: 22,
            column: 2
          },
          end: {
            line: 25,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 22,
            column: 2
          },
          end: {
            line: 25,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 22
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "706ff77feed03f8de73212117c1fb36840db55a4"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2ijo9jc43y = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2ijo9jc43y();
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }








// This uses an SVG spritesheet which must be injected once per page.
// The approach is detailed [here](https://css-tricks.com/svg-sprites-use-better-icon-fonts/)
// Some of the pros and cons of this approach are detailed [here](https://opendoor.slack.com/archives/C023V2C14BX/p1628281932070100)
cov_2ijo9jc43y().s[0]++;
var Themed = function Themed(_ref) {
  var _ref2;
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  cov_2ijo9jc43y().f[0]++;
  // Determines the base theme to apply to the component library
  var baseThemeName = (cov_2ijo9jc43y().s[1]++, 'baseTheme' in props ? (cov_2ijo9jc43y().b[0][0]++, props.baseTheme) : (cov_2ijo9jc43y().b[0][1]++, props.theme));
  var theme = (cov_2ijo9jc43y().s[2]++, es_theme/* THEME_MAP */.v[(_ref2 = (cov_2ijo9jc43y().b[1][0]++, baseThemeName)) !== null && _ref2 !== void 0 ? _ref2 : (cov_2ijo9jc43y().b[1][1]++, 'eero')]);

  // Applies any theme overrides to the base theme
  cov_2ijo9jc43y().s[3]++;
  if ('baseTheme' in props) {
    cov_2ijo9jc43y().b[2][0]++;
    cov_2ijo9jc43y().s[4]++;
    theme = cloneDeep(theme);
    cov_2ijo9jc43y().s[5]++;
    mergeWith(theme, props.overrides);
  } else {
    cov_2ijo9jc43y().b[2][1]++;
  }
  cov_2ijo9jc43y().s[6]++;
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(Spritesheet/* default */.Z, null), /*#__PURE__*/react.createElement(chakra_ui_system_esm/* ThemeProvider */.f6, _extends({}, props, {
    theme: theme
  }), /*#__PURE__*/react.createElement(FontFace, null), /*#__PURE__*/react.createElement(Reset/* Reset */.A, null), /*#__PURE__*/react.createElement(ReactDatesStyles/* ReactDatesStyles */.i, null), children, /*#__PURE__*/react.createElement(ThemeOverrideExpiredBanner/* ThemeOverrideExpiredBanner */.C, {
    baseTheme: baseThemeName,
    launchDateString: props['launchDateString']
  })));
};

/***/ }),

/***/ 364260:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "xG": function() { return /* binding */ formatCurrency; }
/* harmony export */ });
/* unused harmony exports centsToCurrencyString, centsToPrettyCurrencyString, fractionToPercentString, abbreviationToStateString */
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(892222);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(209653);
/* harmony import */ var core_js_modules_es_number_to_fixed_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(556977);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(241539);
/* harmony import */ var core_js_modules_es_parse_float_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(454678);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(974916);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(339714);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(115306);








var formatCurrency = function formatCurrency(centsValue) {
  var roundToCents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var decimalPlaces = roundToCents ? 2 : 0;
  var parsedNum = centsValue.toString().replace(/\$|,/g, '');
  var rounded = parseFloat(parsedNum).toFixed(decimalPlaces);
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: decimalPlaces
  }).format(isNaN(Number(rounded)) ? 0 : Number(rounded));
};
var centsToCurrencyString = function centsToCurrencyString(valueCents) {
  var roundToCents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return formatCurrency(valueCents / 100, roundToCents);
};
var addSuffix = function addSuffix(dollars, suffix) {
  return "".concat(dollars.toLocaleString('en-US', {
    maximumFractionDigits: suffix === 'k' ? 0 : 1
  })).concat(suffix);
};

// converts currency cents from 24000000 to 240K, 240000000 to 2.4M and
// aspirationally will also handle billions correctly
function centsToPrettyCurrencyString(valueCents) {
  var showDollarSign = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var valueInDollars = Math.round(valueCents / 100);
  var absoluteValue = Math.abs(valueInDollars);
  var showNegative = valueCents < 0 ? '-' : '';
  var isBillions = absoluteValue >= 1000000000;
  var isMillions = absoluteValue >= 1000000;
  var isThousands = absoluteValue >= 1000;
  var suffix = isBillions ? 'B' : isMillions ? 'M' : isThousands ? 'K' : '';
  var formattedString = "".concat(absoluteValue);
  if (isBillions) {
    formattedString = addSuffix(absoluteValue / 1000000000, suffix);
  } else if (isMillions) {
    formattedString = addSuffix(absoluteValue / 1000000, suffix);
  } else if (isThousands) {
    formattedString = addSuffix(Math.round(absoluteValue / 1000), suffix);
  }
  return "".concat(showNegative).concat(showDollarSign ? '$' : '').concat(formattedString);
}

/*
TODO: Migrate to use Intl.NumberFormat once typescript is updated
https://v8.dev/features/intl-numberformat#sign
*/
var fractionToPercentString = function fractionToPercentString(valueFraction) {
  var maximumFractionDigits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var minimumFractionDigits = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  return new Intl.NumberFormat('en-US', {
    maximumFractionDigits: maximumFractionDigits,
    minimumFractionDigits: minimumFractionDigits,
    style: 'percent'
  }).format(valueFraction);
};

// converts state abbreviation to their full name
var abbreviationToStateString = {
  AL: 'alabama',
  AK: 'alaska',
  AZ: 'arizona',
  AR: 'arkansas',
  CA: 'california',
  CO: 'colorado',
  CT: 'connecticut',
  DE: 'delaware',
  FL: 'florida',
  GA: 'georgia',
  HI: 'hawaii',
  ID: 'idaho',
  IL: 'illinois',
  IN: 'indiana',
  IA: 'iowa',
  KS: 'kansas',
  KY: 'kentucky',
  LA: 'louisiana',
  ME: 'maine',
  MD: 'maryland',
  MA: 'massachusetts',
  MI: 'michigan',
  MN: 'minnesota',
  MS: 'mississippi',
  MO: 'missouri',
  MT: 'montana',
  NE: 'nebraska',
  NV: 'nevada',
  NH: 'new_hampshire',
  NJ: 'new_jersey',
  NM: 'new_mexico',
  NY: 'new_york',
  NC: 'north_carolina',
  ND: 'north_dakota',
  OH: 'ohio',
  OK: 'oklahoma',
  OR: 'oregon',
  PA: 'pennsylvania',
  RI: 'rhode_island',
  SC: 'south_carolina',
  SD: 'south_dakota',
  TN: 'tennessee',
  TX: 'texas',
  UT: 'utah',
  VT: 'vermont',
  VA: 'virginia',
  WA: 'washington',
  WV: 'west_virginia',
  WI: 'wisconsin',
  WY: 'wyoming'
};

/***/ }),

/***/ 533733:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ createReactComponent; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
;// CONCATENATED MODULE: ./node_modules/@tabler/icons-react/dist/esm/defaultAttributes.mjs
/**
 * @license @tabler/icons-react v3.36.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

var defaultAttributes = {
  outline: {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  },
  filled: {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "none"
  }
};


//# sourceMappingURL=defaultAttributes.mjs.map

;// CONCATENATED MODULE: ./node_modules/@tabler/icons-react/dist/esm/createReactComponent.mjs
/**
 * @license @tabler/icons-react v3.36.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */




const createReactComponent = (type, iconName, iconNamePascal, iconNode) => {
  const Component = (0,react.forwardRef)(
    ({ color = "currentColor", size = 24, stroke = 2, title, className, children, ...rest }, ref) => (0,react.createElement)(
      "svg",
      {
        ref,
        ...defaultAttributes[type],
        width: size,
        height: size,
        className: [`tabler-icon`, `tabler-icon-${iconName}`, className].join(" "),
        ...type === "filled" ? {
          fill: color
        } : {
          strokeWidth: stroke,
          stroke: color
        },
        ...rest
      },
      [
        title && (0,react.createElement)("title", { key: "svg-title" }, title),
        ...iconNode.map(([tag, attrs]) => (0,react.createElement)(tag, attrs)),
        ...Array.isArray(children) ? children : [children]
      ]
    )
  );
  Component.displayName = `${iconNamePascal}`;
  return Component;
};


//# sourceMappingURL=createReactComponent.mjs.map


/***/ }),

/***/ 429513:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ IconShieldLockFilled; }
/* harmony export */ });
/* unused harmony export __iconNode */
/* harmony import */ var _createReactComponent_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(533733);
/**
 * @license @tabler/icons-react v3.36.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */



const __iconNode = [["path", { "d": "M11.998 2l.118 .007l.059 .008l.061 .013l.111 .034a.993 .993 0 0 1 .217 .112l.104 .082l.255 .218a11 11 0 0 0 7.189 2.537l.342 -.01a1 1 0 0 1 1.005 .717a13 13 0 0 1 -9.208 16.25a1 1 0 0 1 -.502 0a13 13 0 0 1 -9.209 -16.25a1 1 0 0 1 1.005 -.717a11 11 0 0 0 7.531 -2.527l.263 -.225l.096 -.075a.993 .993 0 0 1 .217 -.112l.112 -.034a.97 .97 0 0 1 .119 -.021l.115 -.007zm.002 7a2 2 0 0 0 -1.995 1.85l-.005 .15l.005 .15a2 2 0 0 0 .995 1.581v1.769l.007 .117a1 1 0 0 0 1.993 -.117l.001 -1.768a2 2 0 0 0 -1.001 -3.732z", "key": "svg-0" }]];
const IconShieldLockFilled = (0,_createReactComponent_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("filled", "shield-lock-filled", "ShieldLockFilled", __iconNode);


//# sourceMappingURL=IconShieldLockFilled.mjs.map


/***/ }),

/***/ 277178:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ IconTruckFilled; }
/* harmony export */ });
/* unused harmony export __iconNode */
/* harmony import */ var _createReactComponent_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(533733);
/**
 * @license @tabler/icons-react v3.36.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */



const __iconNode = [["path", { "d": "M13 4a1 1 0 0 1 1 1h4a1 1 0 0 1 .783 .378l.074 .108l3 5l.055 .103l.04 .107l.029 .109l.016 .11l.003 .085v6a1 1 0 0 1 -1 1h-1.171a3.001 3.001 0 0 1 -5.658 0h-4.342a3.001 3.001 0 0 1 -5.658 0h-1.171a1 1 0 0 1 -1 -1v-11a2 2 0 0 1 2 -2zm-6 12a1 1 0 1 0 0 2a1 1 0 0 0 0 -2m10 0a1 1 0 1 0 0 2a1 1 0 0 0 0 -2m.434 -9h-3.434v3h5.234z", "key": "svg-0" }]];
const IconTruckFilled = (0,_createReactComponent_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("filled", "truck-filled", "TruckFilled", __iconNode);


//# sourceMappingURL=IconTruckFilled.mjs.map


/***/ })

}]);